// import React, { useState, useRef, useEffect } from 'react';
// import { apiCall } from '@/api/apiCall';
// import { toast } from 'sonner';
// import Sharjah from '@/assets/img/Sharjah.png';
// import carParkIcon from '@/assets/img/car-park-1.png';
// import { useApiQueue } from '@/hooks/useApiQueue';
// import { AssetsPanel } from '../../components/shared/AssetsPanel';
// import { API_CALL_TIME } from '@/constants/constant';

// // ═══════════════════════════════════════════════════════════════════════
// // HELPERS
// // ═══════════════════════════════════════════════════════════════════════
// const groupsToFlat = (groups = []) => {
//     const result = [];
//     groups.forEach(g => {
//         result.push({ name: g.group_name || '', isCategory: true, subCount: '', totalCount: String(g.group_total_qty ?? '-') });
//         (g.items || []).forEach(item => {
//             result.push({ name: item.item_name || '', isCategory: false, subCount: String(item.qty ?? '-'), totalCount: '' });
//         });
//     });
//     return result;
// };

// const flatToGroups = (flat) => {
//     const groups = [];
//     let cur = null;
//     flat.forEach(a => {
//         if (a.isCategory) {
//             if (cur) groups.push(cur);
//             cur = { group_name: a.name, group_total_qty: a.totalCount || '', items: [] };
//         } else if (cur) {
//             cur.items.push({ item_name: a.name, qty: a.subCount || '' });
//         }
//     });
//     if (cur) groups.push(cur);
//     return groups;
// };

// // ═══════════════════════════════════════════════════════════════════════
// // ASSET GROUPS HELPER
// // ═══════════════════════════════════════════════════════════════════════
// function makeAssetGroups(o = {}) {
//     return [
//         { group_name: 'Ticket Dispenser',     group_total_qty: o.ticketDispenser ?? '-', items: [{ item_name: 'DIP G100', qty: '-' }, { item_name: 'G100 64 Bit', qty: o.evG10064 ?? '-' }, { item_name: 'G100 32 Bit', qty: '-' }] },
//         { group_name: 'Ticket Verifier',      group_total_qty: o.ticketVerifier ?? '-',  items: [{ item_name: 'EV DIP G100', qty: o.evDipG100 ?? '-' }, { item_name: 'EV G100 64 Bit', qty: o.evG10064v ?? '-' }, { item_name: 'EV G100 32 Bit', qty: '-' }] },
//         { group_name: "APM's",               group_total_qty: o.apms ?? '-',             items: [{ item_name: 'APM ETS-70', qty: o.apmEts70 ?? '-' }, { item_name: 'APM ETS-100', qty: '-' }] },
//         { group_name: 'PIN Pad',              group_total_qty: o.pinPad ?? '-',           items: [{ item_name: 'IUP250', qty: o.pinPad ?? '-' }] },
//         { group_name: 'Card Reader',          group_total_qty: o.cardReader ?? '-',       items: [{ item_name: 'IUR250', qty: o.cardReader ?? '-' }] },
//         { group_name: 'B-Contactless',        group_total_qty: o.bContactless ?? '-',    items: [{ item_name: 'IUC150', qty: o.bContactless ?? '-' }] },
//         { group_name: 'RFID Reader',          group_total_qty: o.rfidReader ?? '-',       items: [] },
//         { group_name: 'IP Barrier',           group_total_qty: o.ipBarrier ?? '-',        items: [] },
//         { group_name: 'ANPR CAMERA',          group_total_qty: o.anprCamera ?? '-',       items: [{ item_name: 'ARH', qty: o.arh ?? '-' }, { item_name: 'Lumenera', qty: '-' }] },
//         { group_name: 'Sliding Gate',         group_total_qty: '-',                       items: [{ item_name: 'RIGHT', qty: '-' }, { item_name: 'LEFT', qty: '-' }] },
//         { group_name: "PND's",               group_total_qty: '-',                       items: [{ item_name: 'TPAL BNA Large', qty: '-' }, { item_name: 'T-PAL TX', qty: '-' }, { item_name: 'T-PAL V2', qty: '-' }] },
//         { group_name: 'Pound Cashier Device', group_total_qty: '-',                       items: [{ item_name: 'CN-50', qty: '-' }] },
//         { group_name: 'Driver Device',        group_total_qty: o.driverDevice ?? '-',     items: [{ item_name: 'CN-51', qty: o.driverDevice ?? '-' }] },
//         { group_name: 'Enf Device',           group_total_qty: '-',                       items: [{ item_name: 'Oukitel WP2', qty: '-' }, { item_name: 'Doogee V10', qty: '-' }] },
//         { group_name: 'Validation',           group_total_qty: '-',                       items: [{ item_name: 'Lenova Tablet', qty: '-' }] },
//         { group_name: 'Printer',              group_total_qty: '-',                       items: [{ item_name: 'PR-3', qty: '-' }, { item_name: 'SEWOO', qty: '-' }, { item_name: 'BIXOLON', qty: '-' }] },
//         { group_name: 'Tow Truck',            group_total_qty: '-',                       items: [] },
//         { group_name: 'Clamp Vehicle',        group_total_qty: '-',                       items: [] },
//         { group_name: 'Support Vehicle',      group_total_qty: '-',                       items: [] },
//     ];
// }

// // ═══════════════════════════════════════════════════════════════════════
// // CONFIG
// // ═══════════════════════════════════════════════════════════════════════
// const SHARJAH_PROFILE_CONFIG = {
//     sharjha_profile_table: {
//         profileKey:    'sharjah_airport_profile',
//         durationKey:   'sharjah_parking_duration',
//         assetsKey:     'sharjah_assets_deployed',
//         baysKey:       'sharjah_parking_bays',
//         membershipKey: 'sharjah_membership_tariff',
//         showBaysTable:  true,
//         showMembership: true,

//         profileFallback: {
//             table_key: 'sharjah_airport_profile',
//             title: 'Sharjah Airport Parking Profile',
//             data: {
//                 car_park_bays:     { label: 'Total Off Street Car Park Bays', value: '2,368' },
//                 contract_term:     { value: '15 years' },
//                 contract_period:   { start_date: '01.01.2021', end_date: '31.12.2036' },
//                 operational_hours: { value: '24 Hours Per day' },
//                 vat_note:          { value: 'Parking rates including 05% VAT' },
//             },
//         },

//         baysFallback: {
//             table_key: 'sharjah_parking_bays',
//             title: 'SAP-SHARJAH INTERNATIONAL AIRPORT',
//             data: {
//                 total: '2368',
//                 rows: [
//                     { label: 'SHUTTLE BUS ARRIVALS',      value: '5'   },
//                     { label: 'ECONOMY CAR PARK',          value: '300' },
//                     { label: 'MANAGEMENT CAR PARK',       value: '52'  },
//                     { label: 'PREMIUM ARRIVAL CAR PARK',  value: '261' },
//                     { label: 'PREMIUM DEPARTURE CAR PARK',value: '296' },
//                     { label: 'SAP - RC',                  value: '162' },
//                     { label: 'STAFF PARK-A',              value: '193' },
//                     { label: 'STAFF PARK-B',              value: '850' },
//                     { label: 'VISITOR CAR PARK',          value: '83'  },
//                     { label: 'ENGINEERING CAR PARK',      value: '50'  },
//                     { label: 'CARGO CAR PARK',            value: '116' },
//                 ],
//             },
//         },

//         durationFallback: {
//             table_key: 'sharjah_parking_duration',
//             title: 'Casual Parking - Including 05% VAT',
//             data: {
//                 header_row1: [
//                     { label: 'PARKING DURATION', colspan: 1, rowspan: 2 },
//                     { label: 'PARKING AREA',     colspan: 5, rowspan: 1 },
//                 ],
//                 header_row2: [
//                     { key: 'premium_e', label: 'Premium E (Arrival)'   },
//                     { key: 'premium_d', label: 'Premium D (Departure)' },
//                     { key: 'levels',    label: 'Levels'                },
//                     { key: 'economy_c', label: 'Economy C'             },
//                     { key: 'cargo',     label: 'Cargo'                 },
//                 ],
//                 fee_band_row: {
//                     label: 'FEE BAND STRUCTURE',
//                     value: '',
//                     value_colspan: 5,
//                 },
//                 rows: [
//                     {
//                         duration: '0 - 60 Minutes',
//                         cells: {
//                             premium_e: { value: '16' },
//                             premium_d: { value: '16' },
//                             levels:    { value: '0 - 60 Minutes' },
//                             economy_c: { value: '16' },
//                             cargo:     { value: '10 (Per Hour)', rowspan: 3 },
//                         },
//                     },
//                     {
//                         duration: 'Each Additional Hour',
//                         cells: {
//                             premium_e: { value: '11' },
//                             premium_d: { value: '11' },
//                             levels:    { value: '01 - 4 Hours (Per Hour)' },
//                             economy_c: { value: '11' },
//                             cargo:     { skip: true },
//                         },
//                     },
//                     {
//                         duration: 'Each Additional Day',
//                         cells: {
//                             premium_e: { value: '200' },
//                             premium_d: { value: '200' },
//                             levels:    { value: '04 - 24 Hours' },
//                             economy_c: { value: '95' },
//                             cargo:     { skip: true },
//                         },
//                     },
//                     {
//                         duration: 'Lost Ticket Fee (Plus Parking Fees)',
//                         cells: {
//                             premium_e: { value: '210' },
//                             premium_d: { value: '210' },
//                             levels:    { value: 'Each Additional Day' },
//                             economy_c: { value: '95' },
//                             cargo:     { value: '210' },
//                         },
//                     },
//                 ],
//             },
//         },

//         membershipFallback: {
//             table_key: 'sharjah_membership_tariff',
//             title: 'Membership (Excluding 05% VAT)',
//             data: {
//                 columns: ['DEPARTMENT', 'Staff airpark', 'Arrival', 'Departure', 'L-Term', 'Visitor', 'Eng. Dept', 'Cargo'],
//                 rows: [
//                     ['SAA Entities (SAA, DCA, SATA, SAI-VC, PPC)',              'FOC', 'N/A',  'N/A',  'N/A',  'N/A', 'FOC', 'FOC'],
//                     ['Govt. of Sharjah (Police, Immigration, Custom, Others)',   'FOC', 'N/A',  'N/A',  'N/A',  'N/A', 'FOC', 'FOC'],
//                     ['SAS',                                                      '100', 'N/A',  'N/A',  'N/A',  'N/A', '100', '100'],
//                     ['DNATA',                                                    '500', 'N/A',  'N/A',  'N/A',  'N/A', '100', '100'],
//                     ['Air Arabia / Dnfy / SASCO',                                '300', 'N/A',  'N/A',  'N/A',  'N/A', '100', '200'],
//                     ['SMCO',                                                     '150', 'N/A',  'N/A',  'N/A',  'N/A', '100', '100'],
//                     ['Airlines',                                                 '500', 'N/A',  'N/A',  'N/A',  'N/A', '100', '100'],
//                     ['Other Service Providers / Duty Promoters',                 '500', 'N/A',  'N/A',  'N/A',  'N/A', '100', '100'],
//                     ['Centro Hotel',                                             'N/A', '500',  'N/A',  'N/A',  'N/A', 'N/A', 'N/A'],
//                     ['Deliver Vehicles',                                         'N/A', '751',  'N/A',  'N/A',  'N/A', 'N/A', 'N/A'],
//                     ['Staff Transport Bus',                                      'N/A', 'N/A',  'N/A', '2500',  'N/A', 'N/A', 'N/A'],
//                     ['Tourism Companies',                                        'N/A', '2500', '2500', '2500', 'N/A', 'N/A', 'N/A'],
//                 ],
//             },
//         },

//        assetsFallback: {
//     table_key: 'sharjah_assets_deployed',
//     title: 'Sharjah Airport',
//     data: {
//         groups: [
//     {
//         group_name: 'Ticket Dispenser',
//         group_total_qty: '17',
//         items: [
//             { item_name: 'DIP G100', qty: '-' },
//             { item_name: 'G100 64 Bit', qty: '17' },
//             { item_name: 'G100 32 Bit', qty: '-' }
//         ]
//     },
//     {
//         group_name: 'Ticket Verifier',
//         group_total_qty:  '17',
//         items: [
//             { item_name: 'EV DIP G100', qty:  '-' },
//             { item_name: 'EV G100 64 Bit', qty:  '17' },
//             { item_name: 'EV G100 32 Bit', qty: '-' }
//         ]
//     },
//     {
//         group_name: "APM's",
//         group_total_qty:  '10',
//         items: [
//             { item_name: 'APM ETS-70', qty:  '10' },
//             { item_name: 'APM ETS-100', qty: '-' }
//         ]
//     },
//     {
//         group_name: 'PIN Pad',
//         group_total_qty:  '10',
//         items: [{ item_name: 'IUP250', qty: '10' }]
//     },
//     {
//         group_name: 'Card Reader',
//         group_total_qty: '10',
//         items: [{ item_name: 'IUR250', qty: '10' }]
//     },
//     {
//         group_name: 'B-Contactless',
//         group_total_qty: '10',
//         items: [{ item_name: 'IUC150', qty:  '10' }]
//     },
//     {
//         group_name: 'RFID Reader',
//         group_total_qty: '18',
//         items: []
//     },
//     {
//         group_name: 'IP Barrier',
//         group_total_qty:'34',
//         items: []
//     },
//     {
//         group_name: 'ANPR CAMERA',
//         group_total_qty: '34',
//         items: [
//             { item_name: 'ARH', qty:  '34' },
//             { item_name: 'Luminera', qty: '-' }
//         ]
//     },
//     {
//         group_name: 'Sliding Gate',
//         group_total_qty: '-',
//         items: [
//             { item_name: 'RIGHT', qty: '-' },
//             { item_name: 'LEFT', qty: '-' }
//         ]
//     },
//     {
//         group_name: "PND's",
//         group_total_qty: '-',
//         items: [
//             { item_name: 'TPAL- BNA Large', qty: '-' },
//             { item_name: 'T-PAL TX', qty: '-' },
//             { item_name: 'T-PAL V2', qty: '-' }
//         ]
//     },
//     {
//         group_name: 'Pound Cashier Device',
//         group_total_qty: '-',
//         items: [{ item_name: 'CN-50', qty: '-' }]
//     },
//     {
//         group_name: 'Driver Device',
//         group_total_qty:  '4',
//         items: [{ item_name: 'CN-51', qty: '4' }]
//     },
//     {
//         group_name: 'Enf Device',
//         group_total_qty: '-',
//         items: [
//             { item_name: 'Qukitel WP2', qty: '-' },
//             { item_name: 'Dodgee V10', qty: '-' }
//         ]
//     },
//     {
//         group_name: 'Validation',
//         group_total_qty: '-',
//         items: [{ item_name: 'Lenova Tablet', qty: '-' }]
//     },
//     {
//         group_name: 'Printer',
//         group_total_qty: '-',
//         items: [
//             { item_name: 'PR-3', qty: '-' },
//             { item_name: 'SEWOO', qty: '-' },
//             { item_name: 'BIXOLON', qty: '-' }
//         ]
//     },
//     {
//         group_name: 'Tow Truck',
//         group_total_qty: '-',
//         items: []
//     },
//     {
//         group_name: 'Clamp Vehicle',
//         group_total_qty: '-',
//         items: []
//     },
//     {
//         group_name: 'Support Vehicle',
//         group_total_qty: '-',
//         items: []
//     },
// ]
//     },
// },
//     },
// };

// // ═══════════════════════════════════════════════════════════════════════
// // Duration Table Component
// // ═══════════════════════════════════════════════════════════════════════
// const SharjahDurationTable = ({ durationTable, handleDurationCellNew }) => {
//     const dd = durationTable.data;
//     const colKeys = dd.header_row2.filter(h => !h.skip).map(h => h.key);

//     return (
//         <div className="" style={{ maxWidth: '700px' }}>
//             <table className="!border-collapse text-[11px] mx-auto">
//                 <thead>
//                     <tr>
//                         <th colSpan={colKeys.length + 1} className="!border !border-black px-2 py-1 font-bold text-left bg-gray-300">
//                             {durationTable.title}
//                         </th>
//                     </tr>
//                     <tr>
//                         <th rowSpan={1} className="!border !border-black px-2 py-1 font-bold bg-gray-300 text-left align-middle" style={{ minWidth: '160px' }}>
//                             PARKING DURATION
//                         </th>
//                         {dd.header_row1.filter(h => h.label !== 'PARKING DURATION').map((h, i) => (
//                             <th key={i} colSpan={h.colspan || 1} className="!border !border-black px-1.5 py-0.5 font-bold text-center bg-gray-300" style={{ minWidth: '60px' }}>
//                                 {h.label}
//                             </th>
//                         ))}
//                     </tr>
//                     <tr>
//                         <th className="!border !border-black px-1.5 py-0.5 font-semibold text-center bg-gray-300 text-[10px]">
//                             Levels
//                         </th>
//                         {dd.header_row2.filter(h => !h.skip).map((h, i) => (
//                             <th key={i} className="!border !border-black px-1.5 py-0.5 font-semibold text-center bg-gray-300 text-[10px]" style={{ minWidth: '55px' }}>
//                                 {h.label}
//                             </th>
//                         ))}
//                     </tr>
//                     <tr>
//                         <td className="!border !border-black px-2 py-1 font-bold text-[11px]">
//                             {dd.fee_band_row?.label || 'FEE BAND STRUCTURE'}
//                         </td>
//                         <td colSpan={dd.fee_band_row?.value_colspan || colKeys.length} className="!border !border-black px-2 py-1 text-center font-semibold text-[11px]">
//                             {dd.fee_band_row?.value || ''}
//                         </td>
//                     </tr>
//                 </thead>
//                 <tbody>
//                     {dd.rows?.map((row, rIdx) => (
//                         <tr key={rIdx}>
//                             <td className="!border !border-black px-2 py-1 text-[11px]">{row.duration}</td>
//                             {colKeys.map((key, cIdx) => {
//                                 const cell = row.cells?.[key];
//                                 if (!cell) return null;
//                                 if (cell.skip) return null;
//                                 return (
//                                     <td key={cIdx} rowSpan={cell.rowspan || 1} colSpan={cell.colspan || 1} className="!border !border-black px-1.5 py-1 text-center">
//                                         <textarea
//                                             value={cell.value ?? ''}
//                                             onChange={e => handleDurationCellNew(rIdx, key, e.target.value)}
//                                             onInput={e => { const el = e.target; el.style.height = 'auto'; el.style.height = el.scrollHeight + 'px'; }}
//                                             ref={el => { if (el) { el.style.height = 'auto'; el.style.height = el.scrollHeight + 'px'; } }}
//                                             className="w-full !border-0 bg-transparent text-center outline-none text-[11px] resize-none overflow-hidden"
//                                             style={{ fontSize: '11px', lineHeight: '11px', minHeight: '13px', padding: '0' }}
//                                         />
//                                     </td>
//                                 );
//                             })}
//                         </tr>
//                     ))}
//                 </tbody>
//             </table>
//         </div>
//     );
// };

// // ═══════════════════════════════════════════════════════════════════════
// // MAIN COMPONENT
// // ═══════════════════════════════════════════════════════════════════════
// const SharjahAirportProfile = ({ page, year = '', monthNumber = '', contract = '' }) => {
//     const cfg = SHARJAH_PROFILE_CONFIG[page?.type];
//     if (!cfg) return null;

//     const hasFetchedRef = useRef(false);
//     const saveRef       = useRef(null);
//     const [isSaving, setIsSaving] = useState(false);

//     // ── State ─────────────────────────────────────────────────────────
//     const [profileTable,    _setProfileTable]    = useState(cfg.profileFallback);
//     const [durationTable,   _setDurationTable]   = useState(cfg.durationFallback);
//     const [assetsTable,     _setAssetsTable]      = useState(cfg.assetsFallback);
//     const [baysTable,       _setBaysTable]        = useState(cfg.baysFallback || null);
//     const [membershipTable, _setMembershipTable]  = useState(cfg.membershipFallback || null);

//     // ── FIX: Refs to always hold latest state ─────────────────────────
//     const profileRef    = useRef(cfg.profileFallback);
//     const durationRef   = useRef(cfg.durationFallback);
//     const assetsRef     = useRef(cfg.assetsFallback);
//     const baysRef       = useRef(cfg.baysFallback || null);
//     const membershipRef = useRef(cfg.membershipFallback || null);

//     // ── Wrapped setters that keep refs in sync ────────────────────────
//     const setProfileTable = (valOrFn) => {
//         _setProfileTable(prev => {
//             const next = typeof valOrFn === 'function' ? valOrFn(prev) : valOrFn;
//             profileRef.current = next;
//             return next;
//         });
//     };

//     const setDurationTable = (valOrFn) => {
//         _setDurationTable(prev => {
//             const next = typeof valOrFn === 'function' ? valOrFn(prev) : valOrFn;
//             durationRef.current = next;
//             return next;
//         });
//     };

//     const setAssetsTable = (valOrFn) => {
//         _setAssetsTable(prev => {
//             const next = typeof valOrFn === 'function' ? valOrFn(prev) : valOrFn;
//             assetsRef.current = next;
//             return next;
//         });
//     };

//     const setBaysTable = (valOrFn) => {
//         _setBaysTable(prev => {
//             const next = typeof valOrFn === 'function' ? valOrFn(prev) : valOrFn;
//             baysRef.current = next;
//             return next;
//         });
//     };

//     const setMembershipTable = (valOrFn) => {
//         _setMembershipTable(prev => {
//             const next = typeof valOrFn === 'function' ? valOrFn(prev) : valOrFn;
//             membershipRef.current = next;
//             return next;
//         });
//     };

//     const { enqueue } = useApiQueue();

//     // ── Fetch ─────────────────────────────────────────────────────────
//     useEffect(() => {
//         if (hasFetchedRef.current) return;
//         hasFetchedRef.current = true;
//         fetchData();
//     }, [year, monthNumber, contract]);

//     const fetchData = async () => {
//         try {
//             const res = await enqueue(() => apiCall('GET', '/boardpack/get-tables-data', { year, contract, month: monthNumber }));
//             if (!res?.success) return;
//             const data = res?.data || [];
//             const find = (key, fb) => data.find(t => t.table_key === key) || fb;

//             // Use wrapped setters so refs stay in sync after fetch too
//             setProfileTable(find(cfg.profileKey,    cfg.profileFallback));
//             setDurationTable(find(cfg.durationKey,  cfg.durationFallback));
//             setAssetsTable(find(cfg.assetsKey,       cfg.assetsFallback));
//             if (cfg.showBaysTable)  setBaysTable(find(cfg.baysKey,           cfg.baysFallback));
//             if (cfg.showMembership) setMembershipTable(find(cfg.membershipKey, cfg.membershipFallback));
//         } catch (err) {
//             console.error('Fetch error:', err);
//         }
//     };

//     // ── Auto-save ─────────────────────────────────────────────────────
//     const autoSave = () => {
//         if (saveRef.current) clearTimeout(saveRef.current);
//         saveRef.current = setTimeout(saveToAPI, API_CALL_TIME);
//     };

//     // FIX: Reads from refs → always gets LATEST state, not stale closure
//     const saveToAPI = async () => {
//         try {
//             setIsSaving(true);
//             const tables = [
//                 { table_key: profileRef.current.table_key,  title: profileRef.current.title,  data: profileRef.current.data  },
//                 { table_key: durationRef.current.table_key, title: durationRef.current.title, data: durationRef.current.data },
//                 { table_key: assetsRef.current.table_key,   title: assetsRef.current.title,   data: assetsRef.current.data   },
//             ];
//             if (cfg.showBaysTable  && baysRef.current)       tables.push({ table_key: baysRef.current.table_key,       title: baysRef.current.title,       data: baysRef.current.data       });
//             if (cfg.showMembership && membershipRef.current)  tables.push({ table_key: membershipRef.current.table_key, title: membershipRef.current.title, data: membershipRef.current.data });

//             const res = await apiCall('POST', '/boardpack/add-tables-data', {
//                 contract, year, month: monthNumber, created_by: 1, tables,
//             });
//             if (!res?.success) throw new Error(res?.message);
//         } catch (err) {
//             console.error('Save error:', err);
//             toast.error('Failed to save changes');
//         } finally {
//             setIsSaving(false);
//         }
//     };

//     // ── Patch helpers ─────────────────────────────────────────────────
//     const patchProfile = (field, subField, value) => {
//         setProfileTable(prev => ({
//             ...prev,
//             data: { ...prev.data, [field]: subField ? { ...prev.data[field], [subField]: value } : value },
//         }));
//         autoSave();
//     };

//     const handleDurationCellNew = (rIdx, colKey, value) => {
//         setDurationTable(prev => ({
//             ...prev,
//             data: {
//                 ...prev.data,
//                 rows: prev.data.rows.map((row, i) => {
//                     if (i !== rIdx) return row;
//                     return { ...row, cells: { ...row.cells, [colKey]: { ...row.cells?.[colKey], value } } };
//                 }),
//             },
//         }));
//         autoSave();
//     };

//     const handleBayTotal = (value) => {
//         setBaysTable(prev => ({ ...prev, data: { ...prev.data, total: value } }));
//         autoSave();
//     };

//     const handleBayRow = (idx, value) => {
//         setBaysTable(prev => ({
//             ...prev,
//             data: { ...prev.data, rows: prev.data.rows.map((r, i) => i === idx ? { ...r, value } : r) },
//         }));
//         autoSave();
//     };

//     const handleMembershipCell = (rIdx, cIdx, value) => {
//         setMembershipTable(prev => ({
//             ...prev,
//             data: {
//                 ...prev.data,
//                 rows: prev.data.rows.map((r, i) => i === rIdx ? r.map((c, j) => j === cIdx ? value : c) : r),
//             },
//         }));
//         autoSave();
//     };

//     const handleAssetSubCount = (flatIdx, value) => {
//         // FIX: use assetsRef.current so we always get latest groups
//         const flat = groupsToFlat(assetsRef.current.data.groups).map((a, i) => i === flatIdx ? { ...a, subCount: value } : a);
//         setAssetsTable(prev => ({ ...prev, data: { ...prev.data, groups: flatToGroups(flat) } }));
//         autoSave();
//     };

//     const handleAssetTotalCount = (flatIdx, value) => {
//         // FIX: use assetsRef.current so we always get latest groups
//         const flat = groupsToFlat(assetsRef.current.data.groups).map((a, i) => i === flatIdx ? { ...a, totalCount: value } : a);
//         setAssetsTable(prev => ({ ...prev, data: { ...prev.data, groups: flatToGroups(flat) } }));
//         autoSave();
//     };

//     // ── Derived ───────────────────────────────────────────────────────
//     const pd         = profileTable.data;
//     const md         = membershipTable?.data;
//     const bd         = baysTable?.data;
//     const flatAssets = groupsToFlat(assetsTable.data.groups);

//     // ── RENDER ────────────────────────────────────────────────────────
//     return (
//         <div className="min-h-screen p-4 md:p-6 lg:p-4 bg-white">

//             {/* Header */}
//             <div className="flex justify-between items-center mb-2">
//                 <div className="ml-2">
//                     <img src={Sharjah} alt="Sharjah Airport Logo" style={{ height: '50px', objectFit: 'contain' }} />
//                 </div>
//                 <h1 className="text-xl font-bold flex-1 text-center">{profileTable.title}</h1>
//             </div>

//             <div className="flex flex-col lg:flex-row gap-0 !border-2 !border-black p-3">

//                 {/* ══ LEFT ══ */}
//                 <div className="flex-1 pr-4">

//                     {/* Total Bays */}
//                     <div className="flex items-center gap-2 mb-1 ml-4 mt-2">
//                         <img src={carParkIcon} alt="car park" style={{ height: '30px', objectFit: 'contain' }} />
//                         <span className="text-[12px]">
//                             {pd.car_park_bays?.label}{' '}
//                             <strong>
//                                 <input type="text" value={pd.car_park_bays?.value || ''}
//                                     onChange={e => patchProfile('car_park_bays', 'value', e.target.value)}
//                                     className="font-bold outline-none bg-transparent !border-0 text-[12px] w-16" />
//                             </strong>
//                         </span>
//                     </div>

//                     {/* Contract Term */}
//                     <div className="flex items-start gap-2 mb-1 ml-10">
//                         <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//                         <span className="text-[12px] flex items-center flex-wrap gap-2">
//                             Contract term{' '}
//                             <strong><input type="text" value={pd.contract_term?.value || ''}
//                                 onChange={e => patchProfile('contract_term', 'value', e.target.value)}
//                                 className="font-bold outline-none bg-transparent !border-0 text-[12px] w-12" /></strong>
//                             ; start date{' '}
//                             <strong><input type="text" value={pd.contract_period?.start_date || ''}
//                                 onChange={e => patchProfile('contract_period', 'start_date', e.target.value)}
//                                 className="font-bold outline-none bg-transparent !border-0 text-[12px] w-16" /></strong>
//                             {' to '}
//                             <strong><input type="text" value={pd.contract_period?.end_date || ''}
//                                 onChange={e => patchProfile('contract_period', 'end_date', e.target.value)}
//                                 className="font-bold outline-none bg-transparent !border-0 text-[12px]" /></strong>
//                         </span>
//                     </div>

//                     {/* Operational Hours */}
//                     <div className="flex items-center gap-2 mb-1 ml-10">
//                         <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//                         <span className="text-[12px]">
//                             Operational Hours{' '}
//                             <strong><input type="text" value={pd.operational_hours?.value || ''}
//                                 onChange={e => patchProfile('operational_hours', 'value', e.target.value)}
//                                 className="font-bold outline-none bg-transparent !border-0 text-[12px]" /></strong>
//                         </span>
//                     </div>

//                     {/* VAT note */}
//                     <div className="flex items-center gap-2 mb-1 ml-10">
//                         <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//                         <span className="text-[12px]">
//                             <input type="text" value={pd.vat_note?.value || ''}
//                                 onChange={e => patchProfile('vat_note', 'value', e.target.value)}
//                                 className="outline-none bg-transparent !border-0 text-[12px] w-64" />
//                         </span>
//                     </div>

//                     {/* Assets Deployed bullet */}
//                     <div className="flex items-center gap-2 mb-3 ml-10">
//                         <div className="w-3 h-3 rounded-full bg-red-500 flex-shrink-0" />
//                         <span className="text-[12px]">Assets Deployed</span>
//                     </div>

//                     {/* ── Parking Duration Table ── */}
//                     <div className="ml-4 mb-5 ">
//                         <SharjahDurationTable
//                             durationTable={durationTable}
//                             handleDurationCellNew={handleDurationCellNew}
//                         />
//                     </div>

//                     {/* ── Membership + Parking Bays Side by Side ── */}
//                     <div className="ml-4 mb-6 grid grid-cols-1 lg:grid-cols-12 gap-6">

//                         {/* Membership Table */}
//                         {cfg.showMembership && md && (
//                             <div className="border border-black lg:col-span-8">
//                                 <table className="!border-collapse text-[10px] w-full">
//                                     <thead>
//                                         <tr>
//                                             <th colSpan={md.columns.length} className="!border !border-black px-2 py-1 font-bold bg-gray-300 text-start">
//                                                 Membership (Excluding 05% VAT)
//                                             </th>
//                                         </tr>
//                                         <tr>
//                                             <th rowSpan={2} className="!border !border-black px-2 py-1 font-bold bg-gray-300 text-left" style={{ minWidth: '280px' }}>
//                                                 DEPARTMENT
//                                             </th>
//                                             <th colSpan={md.columns.length - 1} className="!border !border-black px-0.5 py-0.5 font-bold text-center bg-gray-300">
//                                                 Area
//                                             </th>
//                                         </tr>
//                                         <tr>
//                                             {md.columns.slice(1).map((col, i) => (
//                                                 <th key={i} className="!border !border-black px-0.5 py-0.5 font-semibold text-center bg-gray-300" style={{ minWidth: '45px' }}>
//                                                     {col}
//                                                 </th>
//                                             ))}
//                                         </tr>
//                                     </thead>
//                                     <tbody>
//                                         {md.rows?.map((row, rIdx) => (
//                                             <tr key={rIdx}>
//                                                 {row.map((cell, cIdx) => (
//                                                     // <td key={cIdx} className="!border !border-black px-0.5 py-0.5 text-[10px]" style={{ minWidth: cIdx === 0 ? '280px' : '45px' }}>
//                                                     //     {cell}
//                                                     // </td>
//                                                     <td 
//                                 key={cIdx} 
//                                 className="!border !border-black px-0.5 py-0.5 text-[10px]" 
//                                 style={{ minWidth: cIdx === 0 ? '280px' : '45px' }}
//                             >
//                                 {cIdx === 0 ? (
//                                     // Department name (first column) - Optional: make editable or keep as text
//                                     <span className="font-medium">{cell}</span>
//                                 ) : (
//                                     // All other columns → Editable Input
//                                     <input
//                                         type="text"
//                                         value={cell || ''}
//                                         onChange={(e) => handleMembershipCell(rIdx, cIdx, e.target.value)}
//                                         className="w-full text-center outline-none bg-transparent border-0 text-[10px] font-medium focus:bg-white focus:border focus:border-blue-500 px-1 py-0.5 rounded"
//                                     />
//                                 )}
//                             </td>
//                                                 ))}
//                                             </tr>
//                                         ))}
//                                     </tbody>
//                                 </table>
//                             </div>
//                         )}

//                         {/* Parking Bays Table */}
//                         {cfg.showBaysTable && bd && (
//                             <div className="border border-black lg:col-span-4">
//                                 <table className="!border-collapse text-[10px] w-full">
//                                     <thead>
//                                         <tr>
//                                             <th className="!border !border-black px-2 py-1 font-bold text-center bg-gray-300" style={{ minWidth: '160px' }}>
//                                                 {baysTable.title}
//                                             </th>
//                                             <th className="!border !border-black px-2 py-0 font-bold text-center bg-gray-300" style={{ minWidth: '60px' }}>
//                                                 Parking Bays <br />
//                                                 <input type="text" value={bd.total || ''}
//                                                     onChange={e => handleBayTotal(e.target.value)}
//                                                     className="font-bold outline-none bg-transparent border-0 text-center text-[10px] w-12" />
//                                             </th>
//                                         </tr>
//                                     </thead>
//                                     <tbody>
//                                         {bd.rows?.map((row, i) => (
//                                             <tr key={i}>
//                                                 <td className="!border !border-black px-1 py-1 text-[10px]">{row.label}</td>
//                                                 <td className="!border !border-black px-1 py-1 text-right">
//                                                     <input type="text" value={row.value || ''}
//                                                         onChange={e => handleBayRow(i, e.target.value)}
//                                                         className="outline-none bg-transparent border-0 text-right text-[10px] w-full p-0" />
//                                                 </td>
//                                             </tr>
//                                         ))}
//                                     </tbody>
//                                 </table>
//                             </div>
//                         )}

//                     </div>
//                 </div>

//                 {/* ══ RIGHT — Assets Panel ══ */}
//                 <AssetsPanel
//                     assetsTable={{ title: assetsTable.title }}
//                     flatAssets={flatAssets}
//                     onSubCount={handleAssetSubCount}
//                     onTotalCount={handleAssetTotalCount}
//                 />

//             </div>

//             {/* {isSaving && (
//                 <div className="fixed bottom-4 right-4 bg-blue-600 text-white text-xs px-3 py-1.5 rounded shadow-lg z-50">
//                     Saving...
//                 </div>
//             )} */}
//         </div>
//     );
// };

// export default SharjahAirportProfile;










// import React, { useState, useRef, useEffect } from 'react';
// import { apiCall } from '@/api/apiCall';
// import { toast } from 'sonner';
// import Sharjah from '@/assets/img/Sharjah.png';
// import carParkIcon from '@/assets/img/car-park-1.png';
// import { useApiQueue } from '@/hooks/useApiQueue';
// import { AssetsPanel } from '../../components/shared/AssetsPanel';
// import { API_CALL_TIME } from '@/constants/constant';

// // ═══════════════════════════════════════════════════════════════════════
// // HELPERS
// // ═══════════════════════════════════════════════════════════════════════
// const groupsToFlat = (groups = []) => {
//     const result = [];
//     groups.forEach(g => {
//         result.push({ name: g.group_name || '', isCategory: true, subCount: '', totalCount: String(g.group_total_qty ?? '-') });
//         (g.items || []).forEach(item => {
//             result.push({ name: item.item_name || '', isCategory: false, subCount: String(item.qty ?? '-'), totalCount: '' });
//         });
//     });
//     return result;
// };

// const flatToGroups = (flat) => {
//     const groups = [];
//     let cur = null;
//     flat.forEach(a => {
//         if (a.isCategory) {
//             if (cur) groups.push(cur);
//             cur = { group_name: a.name, group_total_qty: a.totalCount || '', items: [] };
//         } else if (cur) {
//             cur.items.push({ item_name: a.name, qty: a.subCount || '' });
//         }
//     });
//     if (cur) groups.push(cur);
//     return groups;
// };

// // ═══════════════════════════════════════════════════════════════════════
// // ASSET GROUPS HELPER
// // ═══════════════════════════════════════════════════════════════════════
// function makeAssetGroups(o = {}) {
//     return [
//         { group_name: 'Ticket Dispenser',     group_total_qty: o.ticketDispenser ?? '-', items: [{ item_name: 'DIP G100', qty: '-' }, { item_name: 'G100 64 Bit', qty: o.evG10064 ?? '-' }, { item_name: 'G100 32 Bit', qty: '-' }] },
//         { group_name: 'Ticket Verifier',      group_total_qty: o.ticketVerifier ?? '-',  items: [{ item_name: 'EV DIP G100', qty: o.evDipG100 ?? '-' }, { item_name: 'EV G100 64 Bit', qty: o.evG10064v ?? '-' }, { item_name: 'EV G100 32 Bit', qty: '-' }] },
//         { group_name: "APM's",               group_total_qty: o.apms ?? '-',             items: [{ item_name: 'APM ETS-70', qty: o.apmEts70 ?? '-' }, { item_name: 'APM ETS-100', qty: '-' }] },
//         { group_name: 'PIN Pad',              group_total_qty: o.pinPad ?? '-',           items: [{ item_name: 'IUP250', qty: o.pinPad ?? '-' }] },
//         { group_name: 'Card Reader',          group_total_qty: o.cardReader ?? '-',       items: [{ item_name: 'IUR250', qty: o.cardReader ?? '-' }] },
//         { group_name: 'B-Contactless',        group_total_qty: o.bContactless ?? '-',    items: [{ item_name: 'IUC150', qty: o.bContactless ?? '-' }] },
//         { group_name: 'RFID Reader',          group_total_qty: o.rfidReader ?? '-',       items: [] },
//         { group_name: 'IP Barrier',           group_total_qty: o.ipBarrier ?? '-',        items: [] },
//         { group_name: 'ANPR CAMERA',          group_total_qty: o.anprCamera ?? '-',       items: [{ item_name: 'ARH', qty: o.arh ?? '-' }, { item_name: 'Lumenera', qty: '-' }] },
//         { group_name: 'Sliding Gate',         group_total_qty: '-',                       items: [{ item_name: 'RIGHT', qty: '-' }, { item_name: 'LEFT', qty: '-' }] },
//         { group_name: "PND's",               group_total_qty: '-',                       items: [{ item_name: 'TPAL BNA Large', qty: '-' }, { item_name: 'T-PAL TX', qty: '-' }, { item_name: 'T-PAL V2', qty: '-' }] },
//         { group_name: 'Pound Cashier Device', group_total_qty: '-',                       items: [{ item_name: 'CN-50', qty: '-' }] },
//         { group_name: 'Driver Device',        group_total_qty: o.driverDevice ?? '-',     items: [{ item_name: 'CN-51', qty: o.driverDevice ?? '-' }] },
//         { group_name: 'Enf Device',           group_total_qty: '-',                       items: [{ item_name: 'Oukitel WP2', qty: '-' }, { item_name: 'Doogee V10', qty: '-' }] },
//         { group_name: 'Validation',           group_total_qty: '-',                       items: [{ item_name: 'Lenova Tablet', qty: '-' }] },
//         { group_name: 'Printer',              group_total_qty: '-',                       items: [{ item_name: 'PR-3', qty: '-' }, { item_name: 'SEWOO', qty: '-' }, { item_name: 'BIXOLON', qty: '-' }] },
//         { group_name: 'Tow Truck',            group_total_qty: '-',                       items: [] },
//         { group_name: 'Clamp Vehicle',        group_total_qty: '-',                       items: [] },
//         { group_name: 'Support Vehicle',      group_total_qty: '-',                       items: [] },
//     ];
// }

// // ═══════════════════════════════════════════════════════════════════════
// // CONFIG
// // ═══════════════════════════════════════════════════════════════════════
// const SHARJAH_PROFILE_CONFIG = {
//     sharjha_profile_table: {
//         profileKey:    'sharjah_airport_profile',
//         durationKey:   'sharjah_parking_duration',
//         assetsKey:     'sharjah_assets_deployed',
//         baysKey:       'sharjah_parking_bays',
//         membershipKey: 'sharjah_membership_tariff',
//         showBaysTable:  true,
//         showMembership: true,

//         profileFallback: {
//             table_key: 'sharjah_airport_profile',
//             title: 'Sharjah Airport Parking Profile',
//             data: {
//                 car_park_bays:     { label: 'Total Off Street Car Park Bays', value: '2,368' },
//                 contract_term:     { value: '15 years' },
//                 contract_period:   { start_date: '01.01.2021', end_date: '31.12.2036' },
//                 operational_hours: { value: '24 Hours Per day' },
//                 vat_note:          { value: 'Parking rates including 05% VAT' },
//             },
//         },

//         baysFallback: {
//             table_key: 'sharjah_parking_bays',
//             title: 'SAP-SHARJAH INTERNATIONAL AIRPORT',
//             data: {
//                 total: '2368',
//                 rows: [
//                     { label: 'SHUTTLE BUS ARRIVALS',      value: '5'   },
//                     { label: 'ECONOMY CAR PARK',          value: '300' },
//                     { label: 'MANAGEMENT CAR PARK',       value: '52'  },
//                     { label: 'PREMIUM ARRIVAL CAR PARK',  value: '261' },
//                     { label: 'PREMIUM DEPARTURE CAR PARK',value: '296' },
//                     { label: 'SAP - RC',                  value: '162' },
//                     { label: 'STAFF PARK-A',              value: '193' },
//                     { label: 'STAFF PARK-B',              value: '850' },
//                     { label: 'VISITOR CAR PARK',          value: '83'  },
//                     { label: 'ENGINEERING CAR PARK',      value: '50'  },
//                     { label: 'CARGO CAR PARK',            value: '116' },
//                 ],
//             },
//         },

//         durationFallback: {
//             table_key: 'sharjah_parking_duration',
//             title: 'Casual Parking - Including 05% VAT',
//             data: {
//                 header_row1: [
//                     { label: 'PARKING DURATION', colspan: 1, rowspan: 2 },
//                     { label: 'PARKING AREA',     colspan: 5, rowspan: 1 },
//                 ],
//                 header_row2: [
//                     { key: 'premium_e', label: 'Premium E (Arrival)'   },
//                     { key: 'premium_d', label: 'Premium D (Departure)' },
//                     { key: 'levels',    label: 'Levels'                },
//                     { key: 'economy_c', label: 'Economy C'             },
//                     { key: 'cargo',     label: 'Cargo'                 },
//                 ],
//                 fee_band_row: {
//                     label: 'FEE BAND STRUCTURE',
//                     value: '',
//                     value_colspan: 5,
//                 },
//                 rows: [
//                     {
//                         duration: '0 - 60 Minutes',
//                         cells: {
//                             premium_e: { value: '16' },
//                             premium_d: { value: '16' },
//                             levels:    { value: '0 - 60 Minutes' },
//                             economy_c: { value: '16' },
//                             cargo:     { value: '10 (Per Hour)', rowspan: 3 },
//                         },
//                     },
//                     {
//                         duration: 'Each Additional Hour',
//                         cells: {
//                             premium_e: { value: '11' },
//                             premium_d: { value: '11' },
//                             levels:    { value: '01 - 4 Hours (Per Hour)' },
//                             economy_c: { value: '11' },
//                             cargo:     { skip: true },
//                         },
//                     },
//                     {
//                         duration: 'Each Additional Day',
//                         cells: {
//                             premium_e: { value: '200' },
//                             premium_d: { value: '200' },
//                             levels:    { value: '04 - 24 Hours' },
//                             economy_c: { value: '95' },
//                             cargo:     { skip: true },
//                         },
//                     },
//                     {
//                         duration: 'Lost Ticket Fee (Plus Parking Fees)',
//                         cells: {
//                             premium_e: { value: '210' },
//                             premium_d: { value: '210' },
//                             levels:    { value: 'Each Additional Day' },
//                             economy_c: { value: '95' },
//                             cargo:     { value: '210' },
//                         },
//                     },
//                 ],
//             },
//         },

//         membershipFallback: {
//             table_key: 'sharjah_membership_tariff',
//             title: 'Membership (Excluding 05% VAT)',
//             data: {
//                 columns: ['DEPARTMENT', 'Staff airpark', 'Arrival', 'Departure', 'L-Term', 'Visitor', 'Eng. Dept', 'Cargo'],
//                 rows: [
//                     ['SAA Entities (SAA, DCA, SATA, SAI-VC, PPC)',              'FOC', 'N/A',  'N/A',  'N/A',  'N/A', 'FOC', 'FOC'],
//                     ['Govt. of Sharjah (Police, Immigration, Custom, Others)',   'FOC', 'N/A',  'N/A',  'N/A',  'N/A', 'FOC', 'FOC'],
//                     ['SAS',                                                      '100', 'N/A',  'N/A',  'N/A',  'N/A', '100', '100'],
//                     ['DNATA',                                                    '500', 'N/A',  'N/A',  'N/A',  'N/A', '100', '100'],
//                     ['Air Arabia / Dnfy / SASCO',                                '300', 'N/A',  'N/A',  'N/A',  'N/A', '100', '200'],
//                     ['SMCO',                                                     '150', 'N/A',  'N/A',  'N/A',  'N/A', '100', '100'],
//                     ['Airlines',                                                 '500', 'N/A',  'N/A',  'N/A',  'N/A', '100', '100'],
//                     ['Other Service Providers / Duty Promoters',                 '500', 'N/A',  'N/A',  'N/A',  'N/A', '100', '100'],
//                     ['Centro Hotel',                                             'N/A', '500',  'N/A',  'N/A',  'N/A', 'N/A', 'N/A'],
//                     ['Deliver Vehicles',                                         'N/A', '751',  'N/A',  'N/A',  'N/A', 'N/A', 'N/A'],
//                     ['Staff Transport Bus',                                      'N/A', 'N/A',  'N/A', '2500',  'N/A', 'N/A', 'N/A'],
//                     ['Tourism Companies',                                        'N/A', '2500', '2500', '2500', 'N/A', 'N/A', 'N/A'],
//                 ],
//             },
//         },

//        assetsFallback: {
//     table_key: 'sharjah_assets_deployed',
//     title: 'Sharjah Airport',
//     data: {
//         groups: [
//     {
//         group_name: 'Ticket Dispenser',
//         group_total_qty: '17',
//         items: [
//             { item_name: 'DIP G100', qty: '-' },
//             { item_name: 'G100 64 Bit', qty: '17' },
//             { item_name: 'G100 32 Bit', qty: '-' }
//         ]
//     },
//     {
//         group_name: 'Ticket Verifier',
//         group_total_qty:  '17',
//         items: [
//             { item_name: 'EV DIP G100', qty:  '-' },
//             { item_name: 'EV G100 64 Bit', qty:  '17' },
//             { item_name: 'EV G100 32 Bit', qty: '-' }
//         ]
//     },
//     {
//         group_name: "APM's",
//         group_total_qty:  '10',
//         items: [
//             { item_name: 'APM ETS-70', qty:  '10' },
//             { item_name: 'APM ETS-100', qty: '-' }
//         ]
//     },
//     {
//         group_name: 'PIN Pad',
//         group_total_qty:  '10',
//         items: [{ item_name: 'IUP250', qty: '10' }]
//     },
//     {
//         group_name: 'Card Reader',
//         group_total_qty: '10',
//         items: [{ item_name: 'IUR250', qty: '10' }]
//     },
//     {
//         group_name: 'B-Contactless',
//         group_total_qty: '10',
//         items: [{ item_name: 'IUC150', qty:  '10' }]
//     },
//     {
//         group_name: 'RFID Reader',
//         group_total_qty: '18',
//         items: []
//     },
//     {
//         group_name: 'IP Barrier',
//         group_total_qty:'34',
//         items: []
//     },
//     {
//         group_name: 'ANPR CAMERA',
//         group_total_qty: '34',
//         items: [
//             { item_name: 'ARH', qty:  '34' },
//             { item_name: 'Luminera', qty: '-' }
//         ]
//     },
//     {
//         group_name: 'Sliding Gate',
//         group_total_qty: '-',
//         items: [
//             { item_name: 'RIGHT', qty: '-' },
//             { item_name: 'LEFT', qty: '-' }
//         ]
//     },
//     {
//         group_name: "PND's",
//         group_total_qty: '-',
//         items: [
//             { item_name: 'TPAL- BNA Large', qty: '-' },
//             { item_name: 'T-PAL TX', qty: '-' },
//             { item_name: 'T-PAL V2', qty: '-' }
//         ]
//     },
//     {
//         group_name: 'Pound Cashier Device',
//         group_total_qty: '-',
//         items: [{ item_name: 'CN-50', qty: '-' }]
//     },
//     {
//         group_name: 'Driver Device',
//         group_total_qty:  '4',
//         items: [{ item_name: 'CN-51', qty: '4' }]
//     },
//     {
//         group_name: 'Enf Device',
//         group_total_qty: '-',
//         items: [
//             { item_name: 'Qukitel WP2', qty: '-' },
//             { item_name: 'Dodgee V10', qty: '-' }
//         ]
//     },
//     {
//         group_name: 'Validation',
//         group_total_qty: '-',
//         items: [{ item_name: 'Lenova Tablet', qty: '-' }]
//     },
//     {
//         group_name: 'Printer',
//         group_total_qty: '-',
//         items: [
//             { item_name: 'PR-3', qty: '-' },
//             { item_name: 'SEWOO', qty: '-' },
//             { item_name: 'BIXOLON', qty: '-' }
//         ]
//     },
//     {
//         group_name: 'Tow Truck',
//         group_total_qty: '-',
//         items: []
//     },
//     {
//         group_name: 'Clamp Vehicle',
//         group_total_qty: '-',
//         items: []
//     },
//     {
//         group_name: 'Support Vehicle',
//         group_total_qty: '-',
//         items: []
//     },
// ]
//     },
// },
//     },
// };

// // ═══════════════════════════════════════════════════════════════════════
// // Duration Table Component
// // ═══════════════════════════════════════════════════════════════════════
// const SharjahDurationTable = ({ durationTable, handleDurationCellNew }) => {
//     const dd = durationTable.data;
//     const colKeys = dd.header_row2.filter(h => !h.skip).map(h => h.key);

//     return (
//         <div className="" style={{ maxWidth: '700px' }}>
//             <table className="!border-collapse text-[11px] mx-auto">
//                 <thead>
//                     <tr>
//                         <th colSpan={colKeys.length + 1} className="!border !border-black px-2 py-1 font-bold text-left bg-gray-300">
//                             {durationTable.title}
//                         </th>
//                     </tr>
//                     <tr>
//                         <th rowSpan={1} className="!border !border-black px-2 py-1 font-bold bg-gray-300 text-left align-middle" style={{ minWidth: '160px' }}>
//                             PARKING DURATION
//                         </th>
//                         {dd.header_row1.filter(h => h.label !== 'PARKING DURATION').map((h, i) => (
//                             <th key={i} colSpan={h.colspan || 1} className="!border !border-black px-1.5 py-0.5 font-bold text-center bg-gray-300" style={{ minWidth: '60px' }}>
//                                 {h.label}
//                             </th>
//                         ))}
//                     </tr>
//                     <tr>
//                         <th className="!border !border-black px-1.5 py-0.5 font-semibold text-center bg-gray-300 text-[10px]">
//                             Levels
//                         </th>
//                         {dd.header_row2.filter(h => !h.skip).map((h, i) => (
//                             <th key={i} className="!border !border-black px-1.5 py-0.5 font-semibold text-center bg-gray-300 text-[10px]" style={{ minWidth: '55px' }}>
//                                 {h.label}
//                             </th>
//                         ))}
//                     </tr>
//                     <tr>
//                         <td className="!border !border-black px-2 py-1 font-bold text-[11px]">
//                             {dd.fee_band_row?.label || 'FEE BAND STRUCTURE'}
//                         </td>
//                         <td colSpan={dd.fee_band_row?.value_colspan || colKeys.length} className="!border !border-black px-2 py-1 text-center font-semibold text-[11px]">
//                             {dd.fee_band_row?.value || ''}
//                         </td>
//                     </tr>
//                 </thead>
//                 <tbody>
//                     {dd.rows?.map((row, rIdx) => (
//                         <tr key={rIdx}>
//                             <td className="!border !border-black px-2 py-1 text-[11px]">{row.duration}</td>
//                             {colKeys.map((key, cIdx) => {
//                                 const cell = row.cells?.[key];
//                                 if (!cell) return null;
//                                 if (cell.skip) return null;
//                                 return (
//                                     <td key={cIdx} rowSpan={cell.rowspan || 1} colSpan={cell.colspan || 1} className="!border !border-black px-1.5 py-1 text-center">
//                                         <textarea
//                                             value={cell.value ?? ''}
//                                             onChange={e => handleDurationCellNew(rIdx, key, e.target.value)}
//                                             onInput={e => { const el = e.target; el.style.height = 'auto'; el.style.height = el.scrollHeight + 'px'; }}
//                                             ref={el => { if (el) { el.style.height = 'auto'; el.style.height = el.scrollHeight + 'px'; } }}
//                                             className="w-full !border-0 bg-transparent text-center outline-none text-[11px] resize-none overflow-hidden"
//                                             style={{ fontSize: '11px', lineHeight: '11px', minHeight: '13px', padding: '0' }}
//                                         />
//                                     </td>
//                                 );
//                             })}
//                         </tr>
//                     ))}
//                 </tbody>
//             </table>
//         </div>
//     );
// };

// // ═══════════════════════════════════════════════════════════════════════
// // MAIN COMPONENT
// // ═══════════════════════════════════════════════════════════════════════
// const SharjahAirportProfile = ({ page, year = '', monthNumber = '', month = '', contract = '' }) => {
//     const cfg = SHARJAH_PROFILE_CONFIG[page?.type];
//     if (!cfg) return null;

//     const hasFetchedRef = useRef(false);
//     const saveRef       = useRef(null);
//     const [isSaving, setIsSaving] = useState(false);

//     // 🔥 State for second API (parking bays)
//     const [parkingBaysData, setParkingBaysData] = useState(null);

//     // ── State ─────────────────────────────────────────────────────────
//     const [profileTable,    _setProfileTable]    = useState(cfg.profileFallback);
//     const [durationTable,   _setDurationTable]   = useState(cfg.durationFallback);
//     const [assetsTable,     _setAssetsTable]      = useState(cfg.assetsFallback);
//     const [baysTable,       _setBaysTable]        = useState(cfg.baysFallback || null);
//     const [membershipTable, _setMembershipTable]  = useState(cfg.membershipFallback || null);

//     // ── FIX: Refs to always hold latest state ─────────────────────────
//     const profileRef    = useRef(cfg.profileFallback);
//     const durationRef   = useRef(cfg.durationFallback);
//     const assetsRef     = useRef(cfg.assetsFallback);
//     const baysRef       = useRef(cfg.baysFallback || null);
//     const membershipRef = useRef(cfg.membershipFallback || null);

//     // ── Wrapped setters that keep refs in sync ────────────────────────
//     const setProfileTable = (valOrFn) => {
//         _setProfileTable(prev => {
//             const next = typeof valOrFn === 'function' ? valOrFn(prev) : valOrFn;
//             profileRef.current = next;
//             return next;
//         });
//     };

//     const setDurationTable = (valOrFn) => {
//         _setDurationTable(prev => {
//             const next = typeof valOrFn === 'function' ? valOrFn(prev) : valOrFn;
//             durationRef.current = next;
//             return next;
//         });
//     };

//     const setAssetsTable = (valOrFn) => {
//         _setAssetsTable(prev => {
//             const next = typeof valOrFn === 'function' ? valOrFn(prev) : valOrFn;
//             assetsRef.current = next;
//             return next;
//         });
//     };

//     const setBaysTable = (valOrFn) => {
//         _setBaysTable(prev => {
//             const next = typeof valOrFn === 'function' ? valOrFn(prev) : valOrFn;
//             baysRef.current = next;
//             return next;
//         });
//     };

//     const setMembershipTable = (valOrFn) => {
//         _setMembershipTable(prev => {
//             const next = typeof valOrFn === 'function' ? valOrFn(prev) : valOrFn;
//             membershipRef.current = next;
//             return next;
//         });
//     };

//     const { enqueue } = useApiQueue();

//     // 🔥 Effective total bays - second API se aayega, nahi toh fallback
//     const effectiveTotalBays = parkingBaysData?.total_bays ?? profileTable.data.car_park_bays?.value ?? '0';

//     // ── Fetch BOTH APIs ─────────────────────────────────────────────────────────
//     useEffect(() => {
//         if (hasFetchedRef.current) return;
//         hasFetchedRef.current = true;
//         fetchAllData();
//     }, [year, month, monthNumber, contract]);

//     const fetchAllData = async () => {
//         try {
//             // 🔥 Second API params - 'type' not 'value'
//             const secondApiParams = {
//                 contract: "2051001",
//                 year: year,
//                 month: month,     // using 'month' (string like "Oct")
//                 type: "airport"
//             };
            
//             const [firstApiResponse, secondApiResponse] = await Promise.all([
//                 enqueue(() => apiCall('GET', '/boardpack/get-tables-data', { year, contract, month: monthNumber })),
//                 enqueue(() => apiCall('GET', '/boardpack/parking/bays', secondApiParams))
//             ]);

//             // Process first API response
//             if (firstApiResponse?.success) {
//                 const data = firstApiResponse?.data || [];
//                 const find = (key, fb) => data.find(t => t.table_key === key) || fb;

//                 setProfileTable(find(cfg.profileKey,    cfg.profileFallback));
//                 setDurationTable(find(cfg.durationKey,  cfg.durationFallback));
//                 setAssetsTable(find(cfg.assetsKey,       cfg.assetsFallback));
//                 if (cfg.showBaysTable)  setBaysTable(find(cfg.baysKey,           cfg.baysFallback));
//                 if (cfg.showMembership) setMembershipTable(find(cfg.membershipKey, cfg.membershipFallback));
//             }

//             // 🔥 Process second API response for parking bays
//             if (secondApiResponse?.success && secondApiResponse?.data) {
//                 setParkingBaysData(secondApiResponse.data);
//             } else {
//                 console.warn("Second API failed:", secondApiResponse?.message);
//                 setParkingBaysData(null);
//             }
            
//         } catch (err) {
//             console.error('Fetch error:', err);
//         }
//     };

//     // ── Auto-save ─────────────────────────────────────────────────────
//     const autoSave = () => {
//         if (saveRef.current) clearTimeout(saveRef.current);
//         saveRef.current = setTimeout(saveToAPI, API_CALL_TIME);
//     };

//     // FIX: Reads from refs → always gets LATEST state, not stale closure
//     const saveToAPI = async () => {
//         try {
//             setIsSaving(true);
//             const tables = [
//                 { table_key: profileRef.current.table_key,  title: profileRef.current.title,  data: profileRef.current.data  },
//                 { table_key: durationRef.current.table_key, title: durationRef.current.title, data: durationRef.current.data },
//                 { table_key: assetsRef.current.table_key,   title: assetsRef.current.title,   data: assetsRef.current.data   },
//             ];
//             if (cfg.showBaysTable  && baysRef.current)       tables.push({ table_key: baysRef.current.table_key,       title: baysRef.current.title,       data: baysRef.current.data       });
//             if (cfg.showMembership && membershipRef.current)  tables.push({ table_key: membershipRef.current.table_key, title: membershipRef.current.title, data: membershipRef.current.data });

//             const res = await apiCall('POST', '/boardpack/add-tables-data', {
//                 contract, year, month: monthNumber, created_by: 1, tables,
//             });
//             if (!res?.success) throw new Error(res?.message);
//         } catch (err) {
//             console.error('Save error:', err);
//             toast.error('Failed to save changes');
//         } finally {
//             setIsSaving(false);
//         }
//     };

//     // ── Patch helpers ─────────────────────────────────────────────────
//     const patchProfile = (field, subField, value) => {
//         setProfileTable(prev => ({
//             ...prev,
//             data: { ...prev.data, [field]: subField ? { ...prev.data[field], [subField]: value } : value },
//         }));
//         autoSave();
//     };

//     const handleDurationCellNew = (rIdx, colKey, value) => {
//         setDurationTable(prev => ({
//             ...prev,
//             data: {
//                 ...prev.data,
//                 rows: prev.data.rows.map((row, i) => {
//                     if (i !== rIdx) return row;
//                     return { ...row, cells: { ...row.cells, [colKey]: { ...row.cells?.[colKey], value } } };
//                 }),
//             },
//         }));
//         autoSave();
//     };

//     const handleBayTotal = (value) => {
//         setBaysTable(prev => ({ ...prev, data: { ...prev.data, total: value } }));
//         autoSave();
//     };

//     const handleBayRow = (idx, value) => {
//         setBaysTable(prev => ({
//             ...prev,
//             data: { ...prev.data, rows: prev.data.rows.map((r, i) => i === idx ? { ...r, value } : r) },
//         }));
//         autoSave();
//     };

//     const handleMembershipCell = (rIdx, cIdx, value) => {
//         setMembershipTable(prev => ({
//             ...prev,
//             data: {
//                 ...prev.data,
//                 rows: prev.data.rows.map((r, i) => i === rIdx ? r.map((c, j) => j === cIdx ? value : c) : r),
//             },
//         }));
//         autoSave();
//     };

//     const handleAssetSubCount = (flatIdx, value) => {
//         const flat = groupsToFlat(assetsRef.current.data.groups).map((a, i) => i === flatIdx ? { ...a, subCount: value } : a);
//         setAssetsTable(prev => ({ ...prev, data: { ...prev.data, groups: flatToGroups(flat) } }));
//         autoSave();
//     };

//     const handleAssetTotalCount = (flatIdx, value) => {
//         const flat = groupsToFlat(assetsRef.current.data.groups).map((a, i) => i === flatIdx ? { ...a, totalCount: value } : a);
//         setAssetsTable(prev => ({ ...prev, data: { ...prev.data, groups: flatToGroups(flat) } }));
//         autoSave();
//     };

//     // ── Derived ───────────────────────────────────────────────────────
//     const pd         = profileTable.data;
//     const md         = membershipTable?.data;
//     const bd         = baysTable?.data;
//     const flatAssets = groupsToFlat(assetsTable.data.groups);

//     // ── RENDER ────────────────────────────────────────────────────────
//     return (
//         <div className="min-h-screen p-4 bg-white">

//             {/* Header */}
//             <div className="flex justify-between items-center mb-2">
//                 <div className="ml-2">
//                     <img src={Sharjah} alt="Sharjah Airport Logo" style={{ height: '50px', objectFit: 'contain' }} />
//                 </div>
//                 <h1 className="text-xl font-bold flex-1 text-center">{profileTable.title}</h1>
//             </div>

//             <div className="flex flex-row gap-0 !border-2 !border-black p-3">

//                 {/* ══ LEFT ══ */}
//                 <div className="flex-1 pr-4">

//                     {/* 🔥 READ-ONLY Total Bays - Second API se aayega */}
//                     <div className="flex items-center gap-2 mb-1 ml-4 mt-2">
//                         <img src={carParkIcon} alt="car park" style={{ height: '30px', objectFit: 'contain' }} />
//                         <span className="text-[12px]">
//                             {pd.car_park_bays?.label}{' '}
//                             <strong>
//                                 <input 
//                                     type="text" 
//                                     value={effectiveTotalBays} 
//                                     readOnly 
//                                     disabled
//                                     className="font-bold outline-none bg-transparent !border-0 text-[12px] w-16 cursor-default"
//                                 />
//                             </strong>
//                         </span>
//                     </div>

//                     {/* Contract Term */}
//                     <div className="flex items-start gap-2 mb-1 ml-10">
//                         <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//                         <span className="text-[12px] flex items-center flex-wrap gap-2">
//                             Contract term{' '}
//                             <strong><input type="text" value={pd.contract_term?.value || ''}
//                                 onChange={e => patchProfile('contract_term', 'value', e.target.value)}
//                                 className="font-bold outline-none bg-transparent !border-0 text-[12px] w-12" /></strong>
//                             ; start date{' '}
//                             <strong><input type="text" value={pd.contract_period?.start_date || ''}
//                                 onChange={e => patchProfile('contract_period', 'start_date', e.target.value)}
//                                 className="font-bold outline-none bg-transparent !border-0 text-[12px] w-16" /></strong>
//                             {' to '}
//                             <strong><input type="text" value={pd.contract_period?.end_date || ''}
//                                 onChange={e => patchProfile('contract_period', 'end_date', e.target.value)}
//                                 className="font-bold outline-none bg-transparent !border-0 text-[12px]" /></strong>
//                         </span>
//                     </div>

//                     {/* Operational Hours */}
//                     <div className="flex items-center gap-2 mb-1 ml-10">
//                         <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//                         <span className="text-[12px]">
//                             Operational Hours{' '}
//                             <strong><input type="text" value={pd.operational_hours?.value || ''}
//                                 onChange={e => patchProfile('operational_hours', 'value', e.target.value)}
//                                 className="font-bold outline-none bg-transparent !border-0 text-[12px]" /></strong>
//                         </span>
//                     </div>

//                     {/* VAT note */}
//                     <div className="flex items-center gap-2 mb-1 ml-10">
//                         <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//                         <span className="text-[12px]">
//                             <input type="text" value={pd.vat_note?.value || ''}
//                                 onChange={e => patchProfile('vat_note', 'value', e.target.value)}
//                                 className="outline-none bg-transparent !border-0 text-[12px] w-64" />
//                         </span>
//                     </div>

//                     {/* Assets Deployed bullet */}
//                     <div className="flex items-center gap-2 mb-3 ml-10">
//                         <div className="w-3 h-3 rounded-full bg-red-500 flex-shrink-0" />
//                         <span className="text-[12px]">Assets Deployed</span>
//                     </div>

//                     {/* ── Parking Duration Table ── */}
//                     <div className="ml-4 mb-5 ">
//                         <SharjahDurationTable
//                             durationTable={durationTable}
//                             handleDurationCellNew={handleDurationCellNew}
//                         />
//                     </div>

//                     {/* ── Membership + Parking Bays Side by Side ── */}
//                     <div className="ml-4 mb-6 grid grid-cols-12 gap-6">

//                         {/* Membership Table */}
//                         {cfg.showMembership && md && (
//                             <div className="border border-black col-span-8">
//                                 <table className="!border-collapse text-[10px] w-full">
//                                     <thead>
//                                         <tr>
//                                             <th colSpan={md.columns.length} className="!border !border-black px-2 py-1 font-bold bg-gray-300 text-start">
//                                                 Membership (Excluding 05% VAT)
//                                             </th>
//                                         </tr>
//                                         <tr>
//                                             <th rowSpan={2} className="!border !border-black px-2 py-1 font-bold bg-gray-300 text-left" style={{ minWidth: '280px' }}>
//                                                 DEPARTMENT
//                                             </th>
//                                             <th colSpan={md.columns.length - 1} className="!border !border-black px-0.5 py-0.5 font-bold text-center bg-gray-300">
//                                                 Area
//                                             </th>
//                                         </tr>
//                                         <tr>
//                                             {md.columns.slice(1).map((col, i) => (
//                                                 <th key={i} className="!border !border-black px-0.5 py-0.5 font-semibold text-center bg-gray-300" style={{ minWidth: '45px' }}>
//                                                     {col}
//                                                 </th>
//                                             ))}
//                                         </tr>
//                                     </thead>
//                                     <tbody>
//                                         {md.rows?.map((row, rIdx) => (
//                                             <tr key={rIdx}>
//                                                 {row.map((cell, cIdx) => (
//                                                     <td 
//                                                         key={cIdx} 
//                                                         className="!border !border-black px-0.5 py-0.5 text-[10px]" 
//                                                         style={{ minWidth: cIdx === 0 ? '280px' : '45px' }}
//                                                     >
//                                                         {cIdx === 0 ? (
//                                                             <span className="font-medium">{cell}</span>
//                                                         ) : (
//                                                             <input
//                                                                 type="text"
//                                                                 value={cell || ''}
//                                                                 onChange={(e) => handleMembershipCell(rIdx, cIdx, e.target.value)}
//                                                                 className="w-full text-center outline-none bg-transparent border-0 text-[10px] font-medium focus:bg-white focus:border focus:border-blue-500 px-1 py-0.5 rounded"
//                                                             />
//                                                         )}
//                                                     </td>
//                                                 ))}
//                                             </tr>
//                                         ))}
//                                     </tbody>
//                                 </table>
//                             </div>
//                         )}

//                         {/* Parking Bays Table - Individual bays EDITABLE */}
//                         {cfg.showBaysTable && bd && (
//                             <div className="border border-black col-span-4">
//                                 <table className="!border-collapse text-[10px] w-full">
//                                     <thead>
//                                         <tr>
//                                             <th className="!border !border-black px-2 py-1 font-bold text-center bg-gray-300" style={{ minWidth: '160px' }}>
//                                                 {baysTable.title}
//                                             </th>
//                                             <th className="!border !border-black px-2 py-0 font-bold text-center bg-gray-300" style={{ minWidth: '60px' }}>
//                                                 Parking Bays <br />
//                                                 {/* 🔥 Total bays READ-ONLY - second API se aayega */}
//                                                 <input 
//                                                     type="text" 
//                                                     value={effectiveTotalBays}
//                                                     readOnly 
//                                                     disabled
//                                                     className="font-bold outline-none bg-transparent border-0 text-center text-[10px] w-12 cursor-default"
//                                                 />
//                                             </th>
//                                         </tr>
//                                     </thead>
//                                     <tbody>
//                                         {bd.rows?.map((row, i) => (
//                                             <tr key={i}>
//                                                 <td className="!border !border-black px-1 py-1 text-[10px]">{row.label}</td>
//                                                 <td className="!border !border-black px-1 py-1 text-right">
//                                                     <input type="text" value={row.value || ''}
//                                                         onChange={e => handleBayRow(i, e.target.value)}
//                                                         className="outline-none bg-transparent border-0 text-right text-[10px] w-full p-0" />
//                                                 </td>
//                                             </tr>
//                                         ))}
//                                     </tbody>
//                                 </table>
//                             </div>
//                         )}

//                     </div>
//                 </div>

//                 {/* ══ RIGHT — Assets Panel ══ */}
//                 <AssetsPanel
//                     assetsTable={{ title: assetsTable.title }}
//                     flatAssets={flatAssets}
//                     onSubCount={handleAssetSubCount}
//                     onTotalCount={handleAssetTotalCount}
//                 />

//             </div>
//         </div>
//     );
// };

// export default SharjahAirportProfile;







import React, { useState, useRef, useEffect } from 'react';
import { apiCall } from '@/api/apiCall';
import { toast } from 'sonner';
import Sharjah from '@/assets/img/Sharjah.png';
import carParkIcon from '@/assets/img/car-park-1.png';
import { useApiQueue } from '@/hooks/useApiQueue';
import { AssetsPanel } from '../../components/shared/AssetsPanel';
import { API_CALL_TIME } from '@/constants/constant';

// ═══════════════════════════════════════════════════════════════════════
// HELPERS
// ═══════════════════════════════════════════════════════════════════════
const groupsToFlat = (groups = []) => {
    const result = [];
    groups.forEach(g => {
        result.push({ name: g.group_name || '', isCategory: true, subCount: '', totalCount: String(g.group_total_qty ?? '-') });
        (g.items || []).forEach(item => {
            result.push({ name: item.item_name || '', isCategory: false, subCount: String(item.qty ?? '-'), totalCount: '' });
        });
    });
    return result;
};

const flatToGroups = (flat) => {
    const groups = [];
    let cur = null;
    flat.forEach(a => {
        if (a.isCategory) {
            if (cur) groups.push(cur);
            cur = { group_name: a.name, group_total_qty: a.totalCount || '', items: [] };
        } else if (cur) {
            cur.items.push({ item_name: a.name, qty: a.subCount || '' });
        }
    });
    if (cur) groups.push(cur);
    return groups;
};

// ═══════════════════════════════════════════════════════════════════════
// ASSET GROUPS HELPER
// ═══════════════════════════════════════════════════════════════════════
function makeAssetGroups(o = {}) {
    return [
        { group_name: 'Ticket Dispenser',     group_total_qty: o.ticketDispenser ?? '-', items: [{ item_name: 'DIP G100', qty: '-' }, { item_name: 'G100 64 Bit', qty: o.evG10064 ?? '-' }, { item_name: 'G100 32 Bit', qty: '-' }] },
        { group_name: 'Ticket Verifier',      group_total_qty: o.ticketVerifier ?? '-',  items: [{ item_name: 'EV DIP G100', qty: o.evDipG100 ?? '-' }, { item_name: 'EV G100 64 Bit', qty: o.evG10064v ?? '-' }, { item_name: 'EV G100 32 Bit', qty: '-' }] },
        { group_name: "APM's",               group_total_qty: o.apms ?? '-',             items: [{ item_name: 'APM ETS-70', qty: o.apmEts70 ?? '-' }, { item_name: 'APM ETS-100', qty: '-' }] },
        { group_name: 'PIN Pad',              group_total_qty: o.pinPad ?? '-',           items: [{ item_name: 'IUP250', qty: o.pinPad ?? '-' }] },
        { group_name: 'Card Reader',          group_total_qty: o.cardReader ?? '-',       items: [{ item_name: 'IUR250', qty: o.cardReader ?? '-' }] },
        { group_name: 'B-Contactless',        group_total_qty: o.bContactless ?? '-',    items: [{ item_name: 'IUC150', qty: o.bContactless ?? '-' }] },
        { group_name: 'RFID Reader',          group_total_qty: o.rfidReader ?? '-',       items: [] },
        { group_name: 'IP Barrier',           group_total_qty: o.ipBarrier ?? '-',        items: [] },
        { group_name: 'ANPR CAMERA',          group_total_qty: o.anprCamera ?? '-',       items: [{ item_name: 'ARH', qty: o.arh ?? '-' }, { item_name: 'Lumenera', qty: '-' }] },
        { group_name: 'Sliding Gate',         group_total_qty: '-',                       items: [{ item_name: 'RIGHT', qty: '-' }, { item_name: 'LEFT', qty: '-' }] },
        { group_name: "PND's",               group_total_qty: '-',                       items: [{ item_name: 'TPAL BNA Large', qty: '-' }, { item_name: 'T-PAL TX', qty: '-' }, { item_name: 'T-PAL V2', qty: '-' }] },
        { group_name: 'Pound Cashier Device', group_total_qty: '-',                       items: [{ item_name: 'CN-50', qty: '-' }] },
        { group_name: 'Driver Device',        group_total_qty: o.driverDevice ?? '-',     items: [{ item_name: 'CN-51', qty: o.driverDevice ?? '-' }] },
        { group_name: 'Enf Device',           group_total_qty: '-',                       items: [{ item_name: 'Oukitel WP2', qty: '-' }, { item_name: 'Doogee V10', qty: '-' }] },
        { group_name: 'Validation',           group_total_qty: '-',                       items: [{ item_name: 'Lenova Tablet', qty: '-' }] },
        { group_name: 'Printer',              group_total_qty: '-',                       items: [{ item_name: 'PR-3', qty: '-' }, { item_name: 'SEWOO', qty: '-' }, { item_name: 'BIXOLON', qty: '-' }] },
        { group_name: 'Tow Truck',            group_total_qty: '-',                       items: [] },
        { group_name: 'Clamp Vehicle',        group_total_qty: '-',                       items: [] },
        { group_name: 'Support Vehicle',      group_total_qty: '-',                       items: [] },
    ];
}

// ═══════════════════════════════════════════════════════════════════════
// CONFIG
// ═══════════════════════════════════════════════════════════════════════
const SHARJAH_PROFILE_CONFIG = {
    sharjha_profile_table: {
        profileKey:    'sharjah_airport_profile',
        durationKey:   'sharjah_parking_duration',
        assetsKey:     'sharjah_assets_deployed',
        baysKey:       'sharjah_parking_bays',
        membershipKey: 'sharjah_membership_tariff',
        showBaysTable:  true,
        showMembership: true,

        profileFallback: {
            table_key: 'sharjah_airport_profile',
            title: 'Sharjah Airport Parking Profile',
            data: {
                car_park_bays:     { label: 'Total Off Street Car Park Bays', value: '2,368' },
                contract_term:     { value: '15 years' },
                contract_period:   { start_date: '01.01.2021', end_date: '31.12.2036' },
                operational_hours: { value: '24 Hours Per day' },
                vat_note:          { value: 'Parking rates including 05% VAT' },
            },
        },

        baysFallback: {
            table_key: 'sharjah_parking_bays',
            title: 'SAP-SHARJAH INTERNATIONAL AIRPORT',
            data: {
                total: '2368',
                rows: [
                    { label: 'SHUTTLE BUS ARRIVALS',      value: '5'   },
                    { label: 'ECONOMY CAR PARK',          value: '300' },
                    { label: 'MANAGEMENT CAR PARK',       value: '52'  },
                    { label: 'PREMIUM ARRIVAL CAR PARK',  value: '261' },
                    { label: 'PREMIUM DEPARTURE CAR PARK',value: '296' },
                    { label: 'SAP - RC',                  value: '162' },
                    { label: 'STAFF PARK-A',              value: '193' },
                    { label: 'STAFF PARK-B',              value: '850' },
                    { label: 'VISITOR CAR PARK',          value: '83'  },
                    { label: 'ENGINEERING CAR PARK',      value: '50'  },
                    { label: 'CARGO CAR PARK',            value: '116' },
                ],
            },
        },

        durationFallback: {
            table_key: 'sharjah_parking_duration',
            title: 'Casual Parking - Including 05% VAT',
            data: {
                header_row1: [
                    { label: 'PARKING DURATION', colspan: 1, rowspan: 2 },
                    { label: 'PARKING AREA',     colspan: 5, rowspan: 1 },
                ],
                header_row2: [
                    { key: 'premium_e', label: 'Premium E (Arrival)'   },
                    { key: 'premium_d', label: 'Premium D (Departure)' },
                    { key: 'levels',    label: 'Levels'                },
                    { key: 'economy_c', label: 'Economy C'             },
                    { key: 'cargo',     label: 'Cargo'                 },
                ],
                fee_band_row: {
                    label: 'FEE BAND STRUCTURE',
                    value: '',
                    value_colspan: 5,
                },
                rows: [
                    {
                        duration: '0 - 60 Minutes',
                        cells: {
                            premium_e: { value: '16' },
                            premium_d: { value: '16' },
                            levels:    { value: '0 - 60 Minutes' },
                            economy_c: { value: '16' },
                            cargo:     { value: '10 (Per Hour)', rowspan: 3 },
                        },
                    },
                    {
                        duration: 'Each Additional Hour',
                        cells: {
                            premium_e: { value: '11' },
                            premium_d: { value: '11' },
                            levels:    { value: '01 - 4 Hours (Per Hour)' },
                            economy_c: { value: '11' },
                            cargo:     { skip: true },
                        },
                    },
                    {
                        duration: 'Each Additional Day',
                        cells: {
                            premium_e: { value: '200' },
                            premium_d: { value: '200' },
                            levels:    { value: '04 - 24 Hours' },
                            economy_c: { value: '95' },
                            cargo:     { skip: true },
                        },
                    },
                    {
                        duration: 'Lost Ticket Fee (Plus Parking Fees)',
                        cells: {
                            premium_e: { value: '210' },
                            premium_d: { value: '210' },
                            levels:    { value: 'Each Additional Day' },
                            economy_c: { value: '95' },
                            cargo:     { value: '210' },
                        },
                    },
                ],
            },
        },

        membershipFallback: {
            table_key: 'sharjah_membership_tariff',
            title: 'Membership (Excluding 05% VAT)',
            data: {
                columns: ['DEPARTMENT', 'Staff airpark', 'Arrival', 'Departure', 'L-Term', 'Visitor', 'Eng. Dept', 'Cargo'],
                rows: [
                    ['SAA Entities (SAA, DCA, SATA, SAI-VC, PPC)',              'FOC', 'N/A',  'N/A',  'N/A',  'N/A', 'FOC', 'FOC'],
                    ['Govt. of Sharjah (Police, Immigration, Custom, Others)',   'FOC', 'N/A',  'N/A',  'N/A',  'N/A', 'FOC', 'FOC'],
                    ['SAS',                                                      '100', 'N/A',  'N/A',  'N/A',  'N/A', '100', '100'],
                    ['DNATA',                                                    '500', 'N/A',  'N/A',  'N/A',  'N/A', '100', '100'],
                    ['Air Arabia / Dnfy / SASCO',                                '300', 'N/A',  'N/A',  'N/A',  'N/A', '100', '200'],
                    ['SMCO',                                                     '150', 'N/A',  'N/A',  'N/A',  'N/A', '100', '100'],
                    ['Airlines',                                                 '500', 'N/A',  'N/A',  'N/A',  'N/A', '100', '100'],
                    ['Other Service Providers / Duty Promoters',                 '500', 'N/A',  'N/A',  'N/A',  'N/A', '100', '100'],
                    ['Centro Hotel',                                             'N/A', '500',  'N/A',  'N/A',  'N/A', 'N/A', 'N/A'],
                    ['Deliver Vehicles',                                         'N/A', '751',  'N/A',  'N/A',  'N/A', 'N/A', 'N/A'],
                    ['Staff Transport Bus',                                      'N/A', 'N/A',  'N/A', '2500',  'N/A', 'N/A', 'N/A'],
                    ['Tourism Companies',                                        'N/A', '2500', '2500', '2500', 'N/A', 'N/A', 'N/A'],
                ],
            },
        },

       assetsFallback: {
    table_key: 'sharjah_assets_deployed',
    title: 'Sharjah Airport',
    data: {
        groups: [
    {
        group_name: 'Ticket Dispenser',
        group_total_qty: '17',
        items: [
            { item_name: 'DIP G100', qty: '-' },
            { item_name: 'G100 64 Bit', qty: '17' },
            { item_name: 'G100 32 Bit', qty: '-' }
        ]
    },
    {
        group_name: 'Ticket Verifier',
        group_total_qty:  '17',
        items: [
            { item_name: 'EV DIP G100', qty:  '-' },
            { item_name: 'EV G100 64 Bit', qty:  '17' },
            { item_name: 'EV G100 32 Bit', qty: '-' }
        ]
    },
    {
        group_name: "APM's",
        group_total_qty:  '10',
        items: [
            { item_name: 'APM ETS-70', qty:  '10' },
            { item_name: 'APM ETS-100', qty: '-' }
        ]
    },
    {
        group_name: 'PIN Pad',
        group_total_qty:  '10',
        items: [{ item_name: 'IUP250', qty: '10' }]
    },
    {
        group_name: 'Card Reader',
        group_total_qty: '10',
        items: [{ item_name: 'IUR250', qty: '10' }]
    },
    {
        group_name: 'B-Contactless',
        group_total_qty: '10',
        items: [{ item_name: 'IUC150', qty:  '10' }]
    },
    {
        group_name: 'RFID Reader',
        group_total_qty: '18',
        items: []
    },
    {
        group_name: 'IP Barrier',
        group_total_qty:'34',
        items: []
    },
    {
        group_name: 'ANPR CAMERA',
        group_total_qty: '34',
        items: [
            { item_name: 'ARH', qty:  '34' },
            { item_name: 'Luminera', qty: '-' }
        ]
    },
    {
        group_name: 'Sliding Gate',
        group_total_qty: '-',
        items: [
            { item_name: 'RIGHT', qty: '-' },
            { item_name: 'LEFT', qty: '-' }
        ]
    },
    {
        group_name: "PND's",
        group_total_qty: '-',
        items: [
            { item_name: 'TPAL- BNA Large', qty: '-' },
            { item_name: 'T-PAL TX', qty: '-' },
            { item_name: 'T-PAL V2', qty: '-' }
        ]
    },
    {
        group_name: 'Pound Cashier Device',
        group_total_qty: '-',
        items: [{ item_name: 'CN-50', qty: '-' }]
    },
    {
        group_name: 'Driver Device',
        group_total_qty:  '4',
        items: [{ item_name: 'CN-51', qty: '4' }]
    },
    {
        group_name: 'Enf Device',
        group_total_qty: '-',
        items: [
            { item_name: 'Qukitel WP2', qty: '-' },
            { item_name: 'Dodgee V10', qty: '-' }
        ]
    },
    {
        group_name: 'Validation',
        group_total_qty: '-',
        items: [{ item_name: 'Lenova Tablet', qty: '-' }]
    },
    {
        group_name: 'Printer',
        group_total_qty: '-',
        items: [
            { item_name: 'PR-3', qty: '-' },
            { item_name: 'SEWOO', qty: '-' },
            { item_name: 'BIXOLON', qty: '-' }
        ]
    },
    {
        group_name: 'Tow Truck',
        group_total_qty: '-',
        items: []
    },
    {
        group_name: 'Clamp Vehicle',
        group_total_qty: '-',
        items: []
    },
    {
        group_name: 'Support Vehicle',
        group_total_qty: '-',
        items: []
    },
]
    },
},
    },
};

// ═══════════════════════════════════════════════════════════════════════
// Duration Table Component
// ═══════════════════════════════════════════════════════════════════════
const SharjahDurationTable = ({ durationTable, handleDurationCellNew }) => {
    const dd = durationTable.data;
    const colKeys = dd.header_row2.filter(h => !h.skip).map(h => h.key);

    return (
        <div className="" style={{ maxWidth: '700px' }}>
            <table className="!border-collapse text-[11px] mx-auto">
                <thead>
                    <tr>
                        <th colSpan={colKeys.length + 1} className="!border !border-black px-2 py-1 font-bold text-left bg-gray-300">
                            {durationTable.title}
                        </th>
                    </tr>
                    <tr>
                        <th rowSpan={1} className="!border !border-black px-2 py-1 font-bold bg-gray-300 text-left align-middle" style={{ minWidth: '160px' }}>
                            PARKING DURATION
                        </th>
                        {dd.header_row1.filter(h => h.label !== 'PARKING DURATION').map((h, i) => (
                            <th key={i} colSpan={h.colspan || 1} className="!border !border-black px-1.5 py-0.5 font-bold text-center bg-gray-300" style={{ minWidth: '60px' }}>
                                {h.label}
                            </th>
                        ))}
                    </tr>
                    <tr>
                        <th className="!border !border-black px-1.5 py-0.5 font-semibold text-center bg-gray-300 text-[10px]">
                            Levels
                        </th>
                        {dd.header_row2.filter(h => !h.skip).map((h, i) => (
                            <th key={i} className="!border !border-black px-1.5 py-0.5 font-semibold text-center bg-gray-300 text-[10px]" style={{ minWidth: '55px' }}>
                                {h.label}
                            </th>
                        ))}
                    </tr>
                    <tr>
                        <td className="!border !border-black px-2 py-1 font-bold text-[11px]">
                            {dd.fee_band_row?.label || 'FEE BAND STRUCTURE'}
                        </td>
                        <td colSpan={dd.fee_band_row?.value_colspan || colKeys.length} className="!border !border-black px-2 py-1 text-center font-semibold text-[11px]">
                            {dd.fee_band_row?.value || ''}
                        </td>
                    </tr>
                </thead>
                <tbody>
                    {dd.rows?.map((row, rIdx) => (
                        <tr key={rIdx}>
                            <td className="!border !border-black px-2 py-1 text-[11px]">{row.duration}</td>
                            {colKeys.map((key, cIdx) => {
                                const cell = row.cells?.[key];
                                if (!cell) return null;
                                if (cell.skip) return null;
                                return (
                                    <td key={cIdx} rowSpan={cell.rowspan || 1} colSpan={cell.colspan || 1} className="!border !border-black px-1.5 py-1 text-center">
                                        <textarea
                                            value={cell.value ?? ''}
                                            onChange={e => handleDurationCellNew(rIdx, key, e.target.value)}
                                            onInput={e => { const el = e.target; el.style.height = 'auto'; el.style.height = el.scrollHeight + 'px'; }}
                                            ref={el => { if (el) { el.style.height = 'auto'; el.style.height = el.scrollHeight + 'px'; } }}
                                            className="w-full !border-0 bg-transparent text-center outline-none text-[11px] resize-none overflow-hidden"
                                            style={{ fontSize: '11px', lineHeight: '11px', minHeight: '13px', padding: '0' }}
                                        />
                                    </td>
                                );
                            })}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

// ═══════════════════════════════════════════════════════════════════════
// MAIN COMPONENT
// ═══════════════════════════════════════════════════════════════════════
const SharjahAirportProfile = ({ page, year = '', monthNumber = '', month = '', contract = '' }) => {
    const cfg = SHARJAH_PROFILE_CONFIG[page?.type];
    if (!cfg) return null;

    const hasFetchedRef = useRef(false);
    const saveRef       = useRef(null);
    const [isSaving, setIsSaving] = useState(false);

    // 🔥 State for second API (parking bays)
    const [parkingBaysData, setParkingBaysData] = useState(null);

    // ── State ─────────────────────────────────────────────────────────
    const [profileTable,    _setProfileTable]    = useState(cfg.profileFallback);
    const [durationTable,   _setDurationTable]   = useState(cfg.durationFallback);
    const [assetsTable,     _setAssetsTable]      = useState(cfg.assetsFallback);
    const [baysTable,       _setBaysTable]        = useState(cfg.baysFallback || null);
    const [membershipTable, _setMembershipTable]  = useState(cfg.membershipFallback || null);

    // ── FIX: Refs to always hold latest state ─────────────────────────
    const profileRef    = useRef(cfg.profileFallback);
    const durationRef   = useRef(cfg.durationFallback);
    const assetsRef     = useRef(cfg.assetsFallback);
    const baysRef       = useRef(cfg.baysFallback || null);
    const membershipRef = useRef(cfg.membershipFallback || null);

    // ── Wrapped setters that keep refs in sync ────────────────────────
    const setProfileTable = (valOrFn) => {
        _setProfileTable(prev => {
            const next = typeof valOrFn === 'function' ? valOrFn(prev) : valOrFn;
            profileRef.current = next;
            return next;
        });
    };

    const setDurationTable = (valOrFn) => {
        _setDurationTable(prev => {
            const next = typeof valOrFn === 'function' ? valOrFn(prev) : valOrFn;
            durationRef.current = next;
            return next;
        });
    };

    const setAssetsTable = (valOrFn) => {
        _setAssetsTable(prev => {
            const next = typeof valOrFn === 'function' ? valOrFn(prev) : valOrFn;
            assetsRef.current = next;
            return next;
        });
    };

    const setBaysTable = (valOrFn) => {
        _setBaysTable(prev => {
            const next = typeof valOrFn === 'function' ? valOrFn(prev) : valOrFn;
            baysRef.current = next;
            return next;
        });
    };

    const setMembershipTable = (valOrFn) => {
        _setMembershipTable(prev => {
            const next = typeof valOrFn === 'function' ? valOrFn(prev) : valOrFn;
            membershipRef.current = next;
            return next;
        });
    };

    const { enqueue } = useApiQueue();

    // 🔥 Effective total bays - second API se aayega, nahi toh fallback
    const effectiveTotalBays = parkingBaysData?.total_bays ?? profileTable.data.car_park_bays?.value ?? '0';

    // ── Fetch BOTH APIs ─────────────────────────────────────────────────────────
    useEffect(() => {
        if (hasFetchedRef.current) return;
        hasFetchedRef.current = true;
        fetchAllData();
    }, [year, month, monthNumber, contract]);

    const fetchAllData = async () => {
        try {
            // 🔥 Second API params - 'type' not 'value'
            const secondApiParams = {
                contract: "2051001",
                year: year,
                month: month,     // using 'month' (string like "Oct")
                type: "airport"
            };
            
            const [firstApiResponse, secondApiResponse] = await Promise.all([
                enqueue(() => apiCall('GET', '/boardpack/get-tables-data', { year, contract, month: monthNumber })),
                enqueue(() => apiCall('GET', '/boardpack/parking/bays', secondApiParams))
            ]);

            // Process first API response
            if (firstApiResponse?.success) {
                const data = firstApiResponse?.data || [];
                const find = (key, fb) => data.find(t => t.table_key === key) || fb;

                setProfileTable(find(cfg.profileKey,    cfg.profileFallback));
                setDurationTable(find(cfg.durationKey,  cfg.durationFallback));
                setAssetsTable(find(cfg.assetsKey,       cfg.assetsFallback));
                if (cfg.showBaysTable)  setBaysTable(find(cfg.baysKey,           cfg.baysFallback));
                if (cfg.showMembership) setMembershipTable(find(cfg.membershipKey, cfg.membershipFallback));
            }

            // 🔥 Process second API response for parking bays
            if (secondApiResponse?.success && secondApiResponse?.data) {
                setParkingBaysData(secondApiResponse.data);
            } else {
                console.warn("Second API failed:", secondApiResponse?.message);
                setParkingBaysData(null);
            }
            
        } catch (err) {
            console.error('Fetch error:', err);
        }
    };

    // ── Auto-save ─────────────────────────────────────────────────────
    const autoSave = () => {
        if (saveRef.current) clearTimeout(saveRef.current);
        saveRef.current = setTimeout(saveToAPI, API_CALL_TIME);
    };

    // FIX: Reads from refs → always gets LATEST state, not stale closure
    const saveToAPI = async () => {
        try {
            setIsSaving(true);
            const tables = [
                { table_key: profileRef.current.table_key,  title: profileRef.current.title,  data: profileRef.current.data  },
                { table_key: durationRef.current.table_key, title: durationRef.current.title, data: durationRef.current.data },
                { table_key: assetsRef.current.table_key,   title: assetsRef.current.title,   data: assetsRef.current.data   },
            ];
            if (cfg.showBaysTable  && baysRef.current)       tables.push({ table_key: baysRef.current.table_key,       title: baysRef.current.title,       data: baysRef.current.data       });
            if (cfg.showMembership && membershipRef.current)  tables.push({ table_key: membershipRef.current.table_key, title: membershipRef.current.title, data: membershipRef.current.data });

            const res = await apiCall('POST', '/boardpack/add-tables-data', {
                contract, year, month: monthNumber, created_by: 1, tables,
            });
            if (!res?.success) throw new Error(res?.message);
        } catch (err) {
            console.error('Save error:', err);
            toast.error('Failed to save changes');
        } finally {
            setIsSaving(false);
        }
    };

    // ── Patch helpers ─────────────────────────────────────────────────
    const patchProfile = (field, subField, value) => {
        setProfileTable(prev => ({
            ...prev,
            data: { ...prev.data, [field]: subField ? { ...prev.data[field], [subField]: value } : value },
        }));
        autoSave();
    };

    const handleDurationCellNew = (rIdx, colKey, value) => {
        setDurationTable(prev => ({
            ...prev,
            data: {
                ...prev.data,
                rows: prev.data.rows.map((row, i) => {
                    if (i !== rIdx) return row;
                    return { ...row, cells: { ...row.cells, [colKey]: { ...row.cells?.[colKey], value } } };
                }),
            },
        }));
        autoSave();
    };

    const handleBayTotal = (value) => {
        setBaysTable(prev => ({ ...prev, data: { ...prev.data, total: value } }));
        autoSave();
    };

    const handleBayRow = (idx, value) => {
        setBaysTable(prev => ({
            ...prev,
            data: { ...prev.data, rows: prev.data.rows.map((r, i) => i === idx ? { ...r, value } : r) },
        }));
        autoSave();
    };

    const handleMembershipCell = (rIdx, cIdx, value) => {
        setMembershipTable(prev => ({
            ...prev,
            data: {
                ...prev.data,
                rows: prev.data.rows.map((r, i) => i === rIdx ? r.map((c, j) => j === cIdx ? value : c) : r),
            },
        }));
        autoSave();
    };

    const handleAssetSubCount = (flatIdx, value) => {
        const flat = groupsToFlat(assetsRef.current.data.groups).map((a, i) => i === flatIdx ? { ...a, subCount: value } : a);
        setAssetsTable(prev => ({ ...prev, data: { ...prev.data, groups: flatToGroups(flat) } }));
        autoSave();
    };

    const handleAssetTotalCount = (flatIdx, value) => {
        const flat = groupsToFlat(assetsRef.current.data.groups).map((a, i) => i === flatIdx ? { ...a, totalCount: value } : a);
        setAssetsTable(prev => ({ ...prev, data: { ...prev.data, groups: flatToGroups(flat) } }));
        autoSave();
    };

    // ── Derived ───────────────────────────────────────────────────────
    const pd         = profileTable.data;
    const md         = membershipTable?.data;
    const bd         = baysTable?.data;
    const flatAssets = groupsToFlat(assetsTable.data.groups);

    // ── RENDER ────────────────────────────────────────────────────────
    return (
        <div className="min-h-screen p-4 bg-white">

            {/* Header */}
            <div className="flex justify-between items-center mb-2">
                <div className="ml-2">
                    <img src={Sharjah} alt="Sharjah Airport Logo" style={{ height: '50px', objectFit: 'contain' }} />
                </div>
                <h1 className="text-xl font-bold flex-1 text-center">{profileTable.title}</h1>
            </div>

            <div className="flex flex-row gap-0 !border-2 !border-black p-3">

                {/* ══ LEFT ══ */}
                <div className="flex-1 pr-4">

                    {/* 🔥 READ-ONLY Total Bays - Second API se aayega */}
                    <div className="flex items-center gap-2 mb-1 ml-4 mt-2">
                        <img src={carParkIcon} alt="car park" style={{ height: '30px', objectFit: 'contain' }} />
                        <span className="text-[12px]">
                            {pd.car_park_bays?.label}{' '}
                            <strong>
                                <input 
                                    type="text" 
                                    value={effectiveTotalBays} 
                                    readOnly 
                                    disabled
                                    className="font-bold outline-none bg-transparent !border-0 text-[12px] w-16 cursor-default"
                                />
                            </strong>
                        </span>
                    </div>

                    {/* Contract Term */}
                   <div className="flex items-start gap-2 mb-1 ml-10">
    <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0 mt-[4px]" />

    <span className="text-[12px] flex items-center flex-wrap gap-[1px]">
        Contract term
        <strong>
            <input
                type="text"
                value={pd.contract_term?.value || ''}
                onChange={e => patchProfile('contract_term', 'value', e.target.value)}
                className="font-bold outline-none bg-transparent border-0 text-[12px] px-0"
                style={{
                    width: `calc(${(pd.contract_term?.value || '').length || 1}ch - 3px)`
                }}
            />
        </strong>
        ;

        <span className="ml-[2px]">start date</span>

        <strong>
            <input
                type="text"
                value={pd.contract_period?.start_date || ''}
                onChange={e => patchProfile('contract_period', 'start_date', e.target.value)}
                className="font-bold outline-none bg-transparent border-0 text-[12px] px-0"
                style={{
                    width: `calc(${(pd.contract_period?.start_date || '').length || 1}ch - 3px)`
                }}
            />
        </strong>

        <span className="mx-[1px]">to</span>

        <strong>
            <input
                type="text"
                value={pd.contract_period?.end_date || ''}
                onChange={e => patchProfile('contract_period', 'end_date', e.target.value)}
                className="font-bold outline-none bg-transparent border-0 text-[12px] px-0"
                style={{
                    width: `calc(${(pd.contract_period?.end_date || '').length || 1}ch - 3px)`
                }}
            />
        </strong>
    </span>
</div>

{/* Operational Hours */}
<div className="flex items-center gap-2 mb-1 ml-10">
    <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />

    <span className="text-[12px] flex items-center gap-[2px]">
        Operational Hours
        <strong>
            <input
                type="text"
                value={pd.operational_hours?.value || ''}
                onChange={e => patchProfile('operational_hours', 'value', e.target.value)}
                className="font-bold outline-none bg-transparent border-0 text-[12px] px-0"
                style={{
                    width: `calc(${(pd.operational_hours?.value || '').length || 1}ch - 3px)`
                }}
            />
        </strong>
    </span>
</div>

{/* VAT note */}
<div className="flex items-center gap-2 mb-1 ml-10">
    <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />

    <span className="text-[12px]">
        <input
            type="text"
            value={pd.vat_note?.value || ''}
            onChange={e => patchProfile('vat_note', 'value', e.target.value)}
            className="outline-none bg-transparent border-0 text-[12px] px-0"
            style={{
                width: `calc(${(pd.vat_note?.value || '').length || 10}ch - 3px)`
            }}
        />
    </span>
</div>

                    {/* Assets Deployed bullet */}
                    <div className="flex items-center gap-2 mb-3 ml-10">
                        <div className="w-3 h-3 rounded-full bg-red-500 flex-shrink-0" />
                        <span className="text-[12px]">Assets Deployed</span>
                    </div>

                    {/* ── Parking Duration Table ── */}
                    <div className="ml-4 mb-5 ">
                        <SharjahDurationTable
                            durationTable={durationTable}
                            handleDurationCellNew={handleDurationCellNew}
                        />
                    </div>

                    {/* ── Membership + Parking Bays Side by Side ── */}
                    <div className="ml-4 mb-6 grid grid-cols-12 gap-6">

                        {/* Membership Table */}
                        {cfg.showMembership && md && (
                            <div className="border border-black col-span-8">
                                <table className="!border-collapse text-[10px] w-full">
                                    <thead>
                                        <tr>
                                            <th colSpan={md.columns.length} className="!border !border-black px-2 py-1 font-bold bg-gray-300 text-start">
                                                Membership (Excluding 05% VAT)
                                            </th>
                                        </tr>
                                        <tr>
                                            <th rowSpan={2} className="!border !border-black px-2 py-1 font-bold bg-gray-300 text-left" style={{ minWidth: '280px' }}>
                                                DEPARTMENT
                                            </th>
                                            <th colSpan={md.columns.length - 1} className="!border !border-black px-0.5 py-0.5 font-bold text-center bg-gray-300">
                                                Area
                                            </th>
                                        </tr>
                                        <tr>
                                            {md.columns.slice(1).map((col, i) => (
                                                <th key={i} className="!border !border-black px-0.5 py-0.5 font-semibold text-center bg-gray-300" style={{ minWidth: '45px' }}>
                                                    {col}
                                                </th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {md.rows?.map((row, rIdx) => (
                                            <tr key={rIdx}>
                                                {row.map((cell, cIdx) => (
                                                    <td 
                                                        key={cIdx} 
                                                        className="!border !border-black px-0.5 py-0.5 text-[10px]" 
                                                        style={{ minWidth: cIdx === 0 ? '280px' : '45px' }}
                                                    >
                                                        {cIdx === 0 ? (
                                                            <span className="font-medium">{cell}</span>
                                                        ) : (
                                                            <input
                                                                type="text"
                                                                value={cell || ''}
                                                                onChange={(e) => handleMembershipCell(rIdx, cIdx, e.target.value)}
                                                                className="w-full text-center outline-none bg-transparent border-0 text-[10px] font-medium focus:bg-white focus:border focus:border-blue-500 px-1 py-0.5 rounded"
                                                            />
                                                        )}
                                                    </td>
                                                ))}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}

                        {/* Parking Bays Table - Individual bays EDITABLE */}
                        {cfg.showBaysTable && bd && (
                            <div className="border border-black col-span-4">
                                <table className="!border-collapse text-[10px] w-full">
                                    <thead>
                                        <tr>
                                            <th className="!border !border-black px-2 py-1 font-bold text-center bg-gray-300" style={{ minWidth: '160px' }}>
                                                {baysTable.title}
                                            </th>
                                            <th className="!border !border-black px-2 py-0 font-bold text-center bg-gray-300" style={{ minWidth: '60px' }}>
                                                Parking Bays <br />
                                                {/* 🔥 Total bays READ-ONLY - second API se aayega */}
                                                <input 
                                                    type="text" 
                                                    value={effectiveTotalBays}
                                                    readOnly 
                                                    disabled
                                                    className="font-bold outline-none bg-transparent border-0 text-center text-[10px] w-12 cursor-default"
                                                />
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {bd.rows?.map((row, i) => (
                                            <tr key={i}>
                                                <td className="!border !border-black px-1 py-1 text-[10px]">{row.label}</td>
                                                <td className="!border !border-black px-1 py-1 text-right">
                                                    <input type="text" value={row.value || ''}
                                                        onChange={e => handleBayRow(i, e.target.value)}
                                                        className="outline-none bg-transparent border-0 text-right text-[10px] w-full p-0" />
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}

                    </div>
                </div>

                {/* ══ RIGHT — Assets Panel ══ */}
                <AssetsPanel
                    assetsTable={{ title: assetsTable.title }}
                    flatAssets={flatAssets}
                    onSubCount={handleAssetSubCount}
                    onTotalCount={handleAssetTotalCount}
                />

            </div>
        </div>
    );
};

export default SharjahAirportProfile;